import { ResourceStatus } from '../modules/stations/HostingService/common/ExtendedGraphQLTypes';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Cursor: { input: any; output: any; }
  Date: { input: any; output: any; }
  Datetime: { input: any; output: any; }
  DeploymentConfigMap: { input: any; output: any; }
  JSON: { input: any; output: any; }
  UUID: { input: any; output: any; }
};

/** Input Type for the authorizeDatabaseAccessConnection mutation. */
export type AuthorizeDatabaseAccessConnectionInput = {
  sessionId: Scalars['UUID']['input'];
};

/**
 * The upstream address the Relay may dial for this session. Carries nothing
 * else: the Relay forwards bytes, and the grants already encode the mode.
 */
export type AuthorizeDatabaseAccessConnectionPayload = {
  __typename?: 'AuthorizeDatabaseAccessConnectionPayload';
  host: Scalars['String']['output'];
  port: Scalars['Int']['output'];
};

export type AxinomServiceDefinition = {
  __typename?: 'AxinomServiceDefinition';
  /** Reads and enables pagination through a set of `AxinomServiceDeploymentManifest`. */
  axinomServiceDeploymentManifests: AxinomServiceDeploymentManifestsConnection;
  /** Reads and enables pagination through a set of `AxinomServicePiletArtifact`. */
  axinomServicePiletArtifacts: AxinomServicePiletArtifactsConnection;
  createdDate: Scalars['Datetime']['output'];
  createdUser: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  limitCpu: Scalars['String']['output'];
  limitRam: Scalars['String']['output'];
  name: Scalars['String']['output'];
  repositoryName: Scalars['String']['output'];
  repositoryTags: Array<ContainerImageDetails>;
  serviceId: Scalars['String']['output'];
  updatedDate: Scalars['Datetime']['output'];
  updatedUser: Scalars['String']['output'];
};


export type AxinomServiceDefinitionAxinomServiceDeploymentManifestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AxinomServiceDeploymentManifestCondition>;
  filter?: InputMaybe<AxinomServiceDeploymentManifestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AxinomServiceDeploymentManifestsOrderBy>>;
};


export type AxinomServiceDefinitionAxinomServicePiletArtifactsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AxinomServicePiletArtifactCondition>;
  filter?: InputMaybe<AxinomServicePiletArtifactFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AxinomServicePiletArtifactsOrderBy>>;
};

/**
 * A condition to be used against `AxinomServiceDefinition` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type AxinomServiceDefinitionCondition = {
  /** Checks for equality with the object’s `createdDate` field. */
  createdDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdUser` field. */
  createdUser?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `limitCpu` field. */
  limitCpu?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `limitRam` field. */
  limitRam?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `repositoryName` field. */
  repositoryName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `serviceId` field. */
  serviceId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `AxinomServiceDefinition` object types. All fields are combined with a logical ‘and.’ */
export type AxinomServiceDefinitionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AxinomServiceDefinitionFilter>>;
  /** Filter by the object’s `axinomServiceDeploymentManifests` relation. */
  axinomServiceDeploymentManifests?: InputMaybe<AxinomServiceDefinitionToManyAxinomServiceDeploymentManifestFilter>;
  /** Some related `axinomServiceDeploymentManifests` exist. */
  axinomServiceDeploymentManifestsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `axinomServicePiletArtifacts` relation. */
  axinomServicePiletArtifacts?: InputMaybe<AxinomServiceDefinitionToManyAxinomServicePiletArtifactFilter>;
  /** Some related `axinomServicePiletArtifacts` exist. */
  axinomServicePiletArtifactsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `createdDate` field. */
  createdDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdUser` field. */
  createdUser?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `limitCpu` field. */
  limitCpu?: InputMaybe<StringFilter>;
  /** Filter by the object’s `limitRam` field. */
  limitRam?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AxinomServiceDefinitionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AxinomServiceDefinitionFilter>>;
  /** Filter by the object’s `repositoryName` field. */
  repositoryName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `serviceId` field. */
  serviceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `AxinomServiceDefinition` */
export type AxinomServiceDefinitionInput = {
  limitCpu: Scalars['String']['input'];
  limitRam: Scalars['String']['input'];
  name: Scalars['String']['input'];
  repositoryName: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};

/** A filter to be used against many `AxinomServiceDeploymentManifest` object types. All fields are combined with a logical ‘and.’ */
export type AxinomServiceDefinitionToManyAxinomServiceDeploymentManifestFilter = {
  /** Every related `AxinomServiceDeploymentManifest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AxinomServiceDeploymentManifestFilter>;
  /** No related `AxinomServiceDeploymentManifest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AxinomServiceDeploymentManifestFilter>;
  /** Some related `AxinomServiceDeploymentManifest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AxinomServiceDeploymentManifestFilter>;
};

/** A filter to be used against many `AxinomServicePiletArtifact` object types. All fields are combined with a logical ‘and.’ */
export type AxinomServiceDefinitionToManyAxinomServicePiletArtifactFilter = {
  /** Every related `AxinomServicePiletArtifact` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<AxinomServicePiletArtifactFilter>;
  /** No related `AxinomServicePiletArtifact` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<AxinomServicePiletArtifactFilter>;
  /** Some related `AxinomServicePiletArtifact` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<AxinomServicePiletArtifactFilter>;
};

/** A connection to a list of `AxinomServiceDefinition` values. */
export type AxinomServiceDefinitionsConnection = {
  __typename?: 'AxinomServiceDefinitionsConnection';
  /** A list of edges which contains the `AxinomServiceDefinition` and cursor to aid in pagination. */
  edges: Array<AxinomServiceDefinitionsEdge>;
  /** A list of `AxinomServiceDefinition` objects. */
  nodes: Array<AxinomServiceDefinition>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AxinomServiceDefinition` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `AxinomServiceDefinition` edge in the connection. */
export type AxinomServiceDefinitionsEdge = {
  __typename?: 'AxinomServiceDefinitionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AxinomServiceDefinition` at the end of the edge. */
  node: AxinomServiceDefinition;
};

/** Methods to use when ordering `AxinomServiceDefinition`. */
export enum AxinomServiceDefinitionsOrderBy {
  CreatedDateAsc = 'CREATED_DATE_ASC',
  CreatedDateDesc = 'CREATED_DATE_DESC',
  CreatedUserAsc = 'CREATED_USER_ASC',
  CreatedUserDesc = 'CREATED_USER_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LimitCpuAsc = 'LIMIT_CPU_ASC',
  LimitCpuDesc = 'LIMIT_CPU_DESC',
  LimitRamAsc = 'LIMIT_RAM_ASC',
  LimitRamDesc = 'LIMIT_RAM_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RepositoryNameAsc = 'REPOSITORY_NAME_ASC',
  RepositoryNameDesc = 'REPOSITORY_NAME_DESC',
  ServiceIdAsc = 'SERVICE_ID_ASC',
  ServiceIdDesc = 'SERVICE_ID_DESC',
  UpdatedDateAsc = 'UPDATED_DATE_ASC',
  UpdatedDateDesc = 'UPDATED_DATE_DESC',
  UpdatedUserAsc = 'UPDATED_USER_ASC',
  UpdatedUserDesc = 'UPDATED_USER_DESC'
}

export type AxinomServiceDeploymentManifest = {
  __typename?: 'AxinomServiceDeploymentManifest';
  /** Reads a single `AxinomServiceDefinition` that is related to this `AxinomServiceDeploymentManifest`. */
  axinomServiceDefinition?: Maybe<AxinomServiceDefinition>;
  configMap: Scalars['JSON']['output'];
  createdDate: Scalars['Datetime']['output'];
  createdUser: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  serviceDefinitionId: Scalars['UUID']['output'];
  updatedDate: Scalars['Datetime']['output'];
  updatedUser: Scalars['String']['output'];
};

/**
 * A condition to be used against `AxinomServiceDeploymentManifest` object types.
 * All fields are tested for equality and combined with a logical ‘and.’
 */
export type AxinomServiceDeploymentManifestCondition = {
  /** Checks for equality with the object’s `configMap` field. */
  configMap?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `createdDate` field. */
  createdDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdUser` field. */
  createdUser?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `serviceDefinitionId` field. */
  serviceDefinitionId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `AxinomServiceDeploymentManifest` object types. All fields are combined with a logical ‘and.’ */
export type AxinomServiceDeploymentManifestFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AxinomServiceDeploymentManifestFilter>>;
  /** Filter by the object’s `axinomServiceDefinition` relation. */
  axinomServiceDefinition?: InputMaybe<AxinomServiceDefinitionFilter>;
  /** Filter by the object’s `configMap` field. */
  configMap?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `createdDate` field. */
  createdDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdUser` field. */
  createdUser?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AxinomServiceDeploymentManifestFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AxinomServiceDeploymentManifestFilter>>;
  /** Filter by the object’s `serviceDefinitionId` field. */
  serviceDefinitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `AxinomServiceDeploymentManifest` */
export type AxinomServiceDeploymentManifestInput = {
  configMap: Scalars['JSON']['input'];
  serviceDefinitionId: Scalars['UUID']['input'];
};

/** A connection to a list of `AxinomServiceDeploymentManifest` values. */
export type AxinomServiceDeploymentManifestsConnection = {
  __typename?: 'AxinomServiceDeploymentManifestsConnection';
  /** A list of edges which contains the `AxinomServiceDeploymentManifest` and cursor to aid in pagination. */
  edges: Array<AxinomServiceDeploymentManifestsEdge>;
  /** A list of `AxinomServiceDeploymentManifest` objects. */
  nodes: Array<AxinomServiceDeploymentManifest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AxinomServiceDeploymentManifest` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `AxinomServiceDeploymentManifest` edge in the connection. */
export type AxinomServiceDeploymentManifestsEdge = {
  __typename?: 'AxinomServiceDeploymentManifestsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AxinomServiceDeploymentManifest` at the end of the edge. */
  node: AxinomServiceDeploymentManifest;
};

/** Methods to use when ordering `AxinomServiceDeploymentManifest`. */
export enum AxinomServiceDeploymentManifestsOrderBy {
  ConfigMapAsc = 'CONFIG_MAP_ASC',
  ConfigMapDesc = 'CONFIG_MAP_DESC',
  CreatedDateAsc = 'CREATED_DATE_ASC',
  CreatedDateDesc = 'CREATED_DATE_DESC',
  CreatedUserAsc = 'CREATED_USER_ASC',
  CreatedUserDesc = 'CREATED_USER_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ServiceDefinitionIdAsc = 'SERVICE_DEFINITION_ID_ASC',
  ServiceDefinitionIdDesc = 'SERVICE_DEFINITION_ID_DESC',
  UpdatedDateAsc = 'UPDATED_DATE_ASC',
  UpdatedDateDesc = 'UPDATED_DATE_DESC',
  UpdatedUserAsc = 'UPDATED_USER_ASC',
  UpdatedUserDesc = 'UPDATED_USER_DESC'
}

export type AxinomServicePiletArtifact = {
  __typename?: 'AxinomServicePiletArtifact';
  /** Reads a single `AxinomServiceDefinition` that is related to this `AxinomServicePiletArtifact`. */
  axinomServiceDefinition?: Maybe<AxinomServiceDefinition>;
  createdDate: Scalars['Datetime']['output'];
  createdUser: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  packageVersion: Scalars['String']['output'];
  serviceDefinitionId: Scalars['UUID']['output'];
  updatedDate: Scalars['Datetime']['output'];
  updatedUser: Scalars['String']['output'];
};

/**
 * A condition to be used against `AxinomServicePiletArtifact` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type AxinomServicePiletArtifactCondition = {
  /** Checks for equality with the object’s `createdDate` field. */
  createdDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdUser` field. */
  createdUser?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `packageVersion` field. */
  packageVersion?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `serviceDefinitionId` field. */
  serviceDefinitionId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `AxinomServicePiletArtifact` object types. All fields are combined with a logical ‘and.’ */
export type AxinomServicePiletArtifactFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<AxinomServicePiletArtifactFilter>>;
  /** Filter by the object’s `axinomServiceDefinition` relation. */
  axinomServiceDefinition?: InputMaybe<AxinomServiceDefinitionFilter>;
  /** Filter by the object’s `createdDate` field. */
  createdDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdUser` field. */
  createdUser?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<AxinomServicePiletArtifactFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<AxinomServicePiletArtifactFilter>>;
  /** Filter by the object’s `packageVersion` field. */
  packageVersion?: InputMaybe<StringFilter>;
  /** Filter by the object’s `serviceDefinitionId` field. */
  serviceDefinitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<StringFilter>;
};

/** A connection to a list of `AxinomServicePiletArtifact` values. */
export type AxinomServicePiletArtifactsConnection = {
  __typename?: 'AxinomServicePiletArtifactsConnection';
  /** A list of edges which contains the `AxinomServicePiletArtifact` and cursor to aid in pagination. */
  edges: Array<AxinomServicePiletArtifactsEdge>;
  /** A list of `AxinomServicePiletArtifact` objects. */
  nodes: Array<AxinomServicePiletArtifact>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `AxinomServicePiletArtifact` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `AxinomServicePiletArtifact` edge in the connection. */
export type AxinomServicePiletArtifactsEdge = {
  __typename?: 'AxinomServicePiletArtifactsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `AxinomServicePiletArtifact` at the end of the edge. */
  node: AxinomServicePiletArtifact;
};

/** Methods to use when ordering `AxinomServicePiletArtifact`. */
export enum AxinomServicePiletArtifactsOrderBy {
  CreatedDateAsc = 'CREATED_DATE_ASC',
  CreatedDateDesc = 'CREATED_DATE_DESC',
  CreatedUserAsc = 'CREATED_USER_ASC',
  CreatedUserDesc = 'CREATED_USER_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PackageVersionAsc = 'PACKAGE_VERSION_ASC',
  PackageVersionDesc = 'PACKAGE_VERSION_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ServiceDefinitionIdAsc = 'SERVICE_DEFINITION_ID_ASC',
  ServiceDefinitionIdDesc = 'SERVICE_DEFINITION_ID_DESC',
  UpdatedDateAsc = 'UPDATED_DATE_ASC',
  UpdatedDateDesc = 'UPDATED_DATE_DESC',
  UpdatedUserAsc = 'UPDATED_USER_ASC',
  UpdatedUserDesc = 'UPDATED_USER_DESC'
}

export type AzureStorageContainer = {
  __typename?: 'AzureStorageContainer';
  hasPublicReadAccess?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  publicUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type AzureStorageContainerPatch = {
  hasPublicReadAccess?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AzureStorageContainerQueryInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  storageAccountName: Scalars['String']['input'];
};

export type AzureStorageContainerQueryPayload = {
  __typename?: 'AzureStorageContainerQueryPayload';
  container?: Maybe<AzureStorageContainer>;
  tenantId?: Maybe<Scalars['UUID']['output']>;
};

/** Input for getting SAS token params for an Azure Storage Container */
export type AzureStorageContainerSasTokenParamsInput = {
  containerName: Scalars['String']['input'];
};

/** Payload containing SAS token params for an Azure Storage Container */
export type AzureStorageContainerSasTokenParamsPayload = {
  __typename?: 'AzureStorageContainerSASTokenParamsPayload';
  /** The IP address or range of IP addresses from which to accept requests. */
  allowedIPs?: Maybe<Scalars['String']['output']>;
  /** Protocol permitted for a request made with the SAS. */
  allowedProtocols?: Maybe<Scalars['String']['output']>;
  /** Permissions granted for the SAS token */
  permissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The time at which the SAS becomes valid. */
  validFrom?: Maybe<Scalars['String']['output']>;
  /** The time at which the SAS becomes invalid. */
  validUntil?: Maybe<Scalars['String']['output']>;
};

export type AzureStorageContainersQueryInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  storageAccountName: Scalars['String']['input'];
};

export type AzureStorageContainersQueryPayload = {
  __typename?: 'AzureStorageContainersQueryPayload';
  containers?: Maybe<Array<Maybe<AzureStorageContainer>>>;
};

/** A filter to be used against Boolean fields. All fields are combined with a logical ‘and.’ */
export type BooleanFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Boolean']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

/** Input Type for the closeDatabaseAccessSession mutation. */
export type CloseDatabaseAccessSessionInput = {
  sessionId: Scalars['UUID']['input'];
};

/**
 * Result of closing a session. Closing an already-closed session succeeds
 * and reports zero terminated backends.
 */
export type CloseDatabaseAccessSessionPayload = {
  __typename?: 'CloseDatabaseAccessSessionPayload';
  sessionId: Scalars['UUID']['output'];
  status: DatabaseAccessSessionStatus;
  terminatedBackends: Scalars['Int']['output'];
};

export type ContainerImageDetails = {
  __typename?: 'ContainerImageDetails';
  containerImageVersion: Scalars['String']['output'];
  fullyQualifiedImageName: Scalars['String']['output'];
  tag: Scalars['String']['output'];
};

export type ContainerRegistryConnection = {
  __typename?: 'ContainerRegistryConnection';
  createdDate: Scalars['Datetime']['output'];
  createdUser: Scalars['String']['output'];
  environmentId: Scalars['UUID']['output'];
  host: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  password?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['UUID']['output'];
  updatedDate: Scalars['Datetime']['output'];
  updatedUser: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

/**
 * A condition to be used against `ContainerRegistryConnection` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ContainerRegistryConnectionCondition = {
  /** Checks for equality with the object’s `createdDate` field. */
  createdDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdUser` field. */
  createdUser?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `host` field. */
  host?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `password` field. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `username` field. */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ContainerRegistryConnection` object types. All fields are combined with a logical ‘and.’ */
export type ContainerRegistryConnectionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ContainerRegistryConnectionFilter>>;
  /** Filter by the object’s `createdDate` field. */
  createdDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdUser` field. */
  createdUser?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `host` field. */
  host?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ContainerRegistryConnectionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ContainerRegistryConnectionFilter>>;
  /** Filter by the object’s `password` field. */
  password?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<StringFilter>;
  /** Filter by the object’s `username` field. */
  username?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `ContainerRegistryConnection` */
export type ContainerRegistryConnectionInput = {
  host: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an update to a `ContainerRegistryConnection`. Fields that are set will be updated. */
export type ContainerRegistryConnectionPatch = {
  host?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `ContainerRegistryConnection` values. */
export type ContainerRegistryConnectionsConnection = {
  __typename?: 'ContainerRegistryConnectionsConnection';
  /** A list of edges which contains the `ContainerRegistryConnection` and cursor to aid in pagination. */
  edges: Array<ContainerRegistryConnectionsEdge>;
  /** A list of `ContainerRegistryConnection` objects. */
  nodes: Array<ContainerRegistryConnection>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ContainerRegistryConnection` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ContainerRegistryConnection` edge in the connection. */
export type ContainerRegistryConnectionsEdge = {
  __typename?: 'ContainerRegistryConnectionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ContainerRegistryConnection` at the end of the edge. */
  node: ContainerRegistryConnection;
};

/** Methods to use when ordering `ContainerRegistryConnection`. */
export enum ContainerRegistryConnectionsOrderBy {
  CreatedDateAsc = 'CREATED_DATE_ASC',
  CreatedDateDesc = 'CREATED_DATE_DESC',
  CreatedUserAsc = 'CREATED_USER_ASC',
  CreatedUserDesc = 'CREATED_USER_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  HostAsc = 'HOST_ASC',
  HostDesc = 'HOST_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PasswordAsc = 'PASSWORD_ASC',
  PasswordDesc = 'PASSWORD_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedDateAsc = 'UPDATED_DATE_ASC',
  UpdatedDateDesc = 'UPDATED_DATE_DESC',
  UpdatedUserAsc = 'UPDATED_USER_ASC',
  UpdatedUserDesc = 'UPDATED_USER_DESC',
  UsernameAsc = 'USERNAME_ASC',
  UsernameDesc = 'USERNAME_DESC'
}

/** All input for the create `AxinomServiceDefinition` mutation. */
export type CreateAxinomServiceDefinitionInput = {
  /** The `AxinomServiceDefinition` to be created by this mutation. */
  axinomServiceDefinition: AxinomServiceDefinitionInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `AxinomServiceDefinition` mutation. */
export type CreateAxinomServiceDefinitionPayload = {
  __typename?: 'CreateAxinomServiceDefinitionPayload';
  /** The `AxinomServiceDefinition` that was created by this mutation. */
  axinomServiceDefinition?: Maybe<AxinomServiceDefinition>;
  /** An edge for our `AxinomServiceDefinition`. May be used by Relay 1. */
  axinomServiceDefinitionEdge?: Maybe<AxinomServiceDefinitionsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AxinomServiceDefinition` mutation. */
export type CreateAxinomServiceDefinitionPayloadAxinomServiceDefinitionEdgeArgs = {
  orderBy?: InputMaybe<Array<AxinomServiceDefinitionsOrderBy>>;
};

/** All input for the create `AxinomServiceDeploymentManifest` mutation. */
export type CreateAxinomServiceDeploymentManifestInput = {
  /** The `AxinomServiceDeploymentManifest` to be created by this mutation. */
  axinomServiceDeploymentManifest: AxinomServiceDeploymentManifestInput;
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** The output of our create `AxinomServiceDeploymentManifest` mutation. */
export type CreateAxinomServiceDeploymentManifestPayload = {
  __typename?: 'CreateAxinomServiceDeploymentManifestPayload';
  /** Reads a single `AxinomServiceDefinition` that is related to this `AxinomServiceDeploymentManifest`. */
  axinomServiceDefinition?: Maybe<AxinomServiceDefinition>;
  /** The `AxinomServiceDeploymentManifest` that was created by this mutation. */
  axinomServiceDeploymentManifest?: Maybe<AxinomServiceDeploymentManifest>;
  /** An edge for our `AxinomServiceDeploymentManifest`. May be used by Relay 1. */
  axinomServiceDeploymentManifestEdge?: Maybe<AxinomServiceDeploymentManifestsEdge>;
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `AxinomServiceDeploymentManifest` mutation. */
export type CreateAxinomServiceDeploymentManifestPayloadAxinomServiceDeploymentManifestEdgeArgs = {
  orderBy?: InputMaybe<Array<AxinomServiceDeploymentManifestsOrderBy>>;
};

/**
 * Input Type for the createAxinomServicePiletArtifact mutation.
 * Expects the serviceDefinitionId and the packaged pilet as a .tgz file.
 */
export type CreateAxinomServicePiletArtifactInput = {
  packageName: Scalars['String']['input'];
  packageVersion: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};

/** Response for createAxinomServicePiletArtifact mutation. */
export type CreateAxinomServicePiletArtifactPayload = {
  __typename?: 'CreateAxinomServicePiletArtifactPayload';
  axinomServicePiletArtifact: AxinomServicePiletArtifact;
};

export type CreateAzureStorageContainerInput = {
  name: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  storageAccountName: Scalars['String']['input'];
};

export type CreateAzureStorageContainerMutationPayload = {
  __typename?: 'CreateAzureStorageContainerMutationPayload';
  container?: Maybe<CreatedAzureStorageContainer>;
};

/** All input for the create `ContainerRegistryConnection` mutation. */
export type CreateContainerRegistryConnectionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ContainerRegistryConnection` to be created by this mutation. */
  containerRegistryConnection: ContainerRegistryConnectionInput;
};

/** The output of our create `ContainerRegistryConnection` mutation. */
export type CreateContainerRegistryConnectionPayload = {
  __typename?: 'CreateContainerRegistryConnectionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `ContainerRegistryConnection` that was created by this mutation. */
  containerRegistryConnection?: Maybe<ContainerRegistryConnection>;
  /** An edge for our `ContainerRegistryConnection`. May be used by Relay 1. */
  containerRegistryConnectionEdge?: Maybe<ContainerRegistryConnectionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our create `ContainerRegistryConnection` mutation. */
export type CreateContainerRegistryConnectionPayloadContainerRegistryConnectionEdgeArgs = {
  orderBy?: InputMaybe<Array<ContainerRegistryConnectionsOrderBy>>;
};

/** All input for the create `ServiceDefinition` mutation. */
export type CreateServiceDefinitionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The `ServiceDefinition` to be created by this mutation. */
  serviceDefinition: ServiceDefinitionInput;
};

/** The output of our create `ServiceDefinition` mutation. */
export type CreateServiceDefinitionPayload = {
  __typename?: 'CreateServiceDefinitionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ServiceDefinition` that was created by this mutation. */
  serviceDefinition?: Maybe<ServiceDefinition>;
  /** An edge for our `ServiceDefinition`. May be used by Relay 1. */
  serviceDefinitionEdge?: Maybe<ServiceDefinitionsEdge>;
};


/** The output of our create `ServiceDefinition` mutation. */
export type CreateServiceDefinitionPayloadServiceDefinitionEdgeArgs = {
  orderBy?: InputMaybe<Array<ServiceDefinitionsOrderBy>>;
};

/**
 * Input Type for the createServiceDeploymentManifest mutation.
 * Expects the serviceId, a name and the config map.
 */
export type CreateServiceDeploymentManifestInput = {
  configMap: Scalars['DeploymentConfigMap']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  serviceId: Scalars['String']['input'];
};

/** Response for createServiceDeploymentManifest mutation. */
export type CreateServiceDeploymentManifestPayload = {
  __typename?: 'CreateServiceDeploymentManifestPayload';
  serviceDeploymentManifest: ServiceDeploymentManifest;
};

/**
 * Input Type for the createServicePiletArtifact mutation.
 * Expects the serviceDefinitionId and the packaged pilet as a .tgz file.
 */
export type CreateServicePiletArtifactInput = {
  packageName: Scalars['String']['input'];
  packageVersion: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};

/** Response for createServicePiletArtifact mutation. */
export type CreateServicePiletArtifactPayload = {
  __typename?: 'CreateServicePiletArtifactPayload';
  servicePiletArtifact: ServicePiletArtifact;
};

export type CreatedAzureStorageContainer = {
  __typename?: 'CreatedAzureStorageContainer';
  hasPublicReadAccess?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  publicUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

export type DatabaseAccessSession = {
  __typename?: 'DatabaseAccessSession';
  closedAt?: Maybe<Scalars['Datetime']['output']>;
  createdDate: Scalars['Datetime']['output'];
  createdUser: Scalars['String']['output'];
  environmentId: Scalars['UUID']['output'];
  expiresAt: Scalars['Datetime']['output'];
  id: Scalars['UUID']['output'];
  roleName: Scalars['String']['output'];
  /** Reads a single `ServiceDefinition` that is related to this `DatabaseAccessSession`. */
  serviceDefinition?: Maybe<ServiceDefinition>;
  serviceDefinitionId: Scalars['UUID']['output'];
  status: DatabaseAccessSessionStatus;
  tenantId: Scalars['UUID']['output'];
  updatedDate: Scalars['Datetime']['output'];
  updatedUser: Scalars['String']['output'];
};

/**
 * A condition to be used against `DatabaseAccessSession` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type DatabaseAccessSessionCondition = {
  /** Checks for equality with the object’s `closedAt` field. */
  closedAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdDate` field. */
  createdDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdUser` field. */
  createdUser?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `expiresAt` field. */
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `roleName` field. */
  roleName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `serviceDefinitionId` field. */
  serviceDefinitionId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<DatabaseAccessSessionStatus>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `DatabaseAccessSession` object types. All fields are combined with a logical ‘and.’ */
export type DatabaseAccessSessionFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DatabaseAccessSessionFilter>>;
  /** Filter by the object’s `closedAt` field. */
  closedAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdDate` field. */
  createdDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdUser` field. */
  createdUser?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `expiresAt` field. */
  expiresAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DatabaseAccessSessionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DatabaseAccessSessionFilter>>;
  /** Filter by the object’s `roleName` field. */
  roleName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `serviceDefinition` relation. */
  serviceDefinition?: InputMaybe<ServiceDefinitionFilter>;
  /** Filter by the object’s `serviceDefinitionId` field. */
  serviceDefinitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<DatabaseAccessSessionStatusFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<StringFilter>;
};

export enum DatabaseAccessSessionStatus {
  /** Closed */
  Closed = 'CLOSED',
  /** Closing */
  Closing = 'CLOSING',
  /** Open */
  Open = 'OPEN'
}

/** A filter to be used against DatabaseAccessSessionStatus fields. All fields are combined with a logical ‘and.’ */
export type DatabaseAccessSessionStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<DatabaseAccessSessionStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<DatabaseAccessSessionStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<DatabaseAccessSessionStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<DatabaseAccessSessionStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<DatabaseAccessSessionStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<DatabaseAccessSessionStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<DatabaseAccessSessionStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<DatabaseAccessSessionStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<DatabaseAccessSessionStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<DatabaseAccessSessionStatus>>;
};

/** A connection to a list of `DatabaseAccessSession` values. */
export type DatabaseAccessSessionsConnection = {
  __typename?: 'DatabaseAccessSessionsConnection';
  /** A list of edges which contains the `DatabaseAccessSession` and cursor to aid in pagination. */
  edges: Array<DatabaseAccessSessionsEdge>;
  /** A list of `DatabaseAccessSession` objects. */
  nodes: Array<DatabaseAccessSession>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DatabaseAccessSession` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DatabaseAccessSession` edge in the connection. */
export type DatabaseAccessSessionsEdge = {
  __typename?: 'DatabaseAccessSessionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DatabaseAccessSession` at the end of the edge. */
  node: DatabaseAccessSession;
};

/** Methods to use when ordering `DatabaseAccessSession`. */
export enum DatabaseAccessSessionsOrderBy {
  ClosedAtAsc = 'CLOSED_AT_ASC',
  ClosedAtDesc = 'CLOSED_AT_DESC',
  CreatedDateAsc = 'CREATED_DATE_ASC',
  CreatedDateDesc = 'CREATED_DATE_DESC',
  CreatedUserAsc = 'CREATED_USER_ASC',
  CreatedUserDesc = 'CREATED_USER_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  ExpiresAtAsc = 'EXPIRES_AT_ASC',
  ExpiresAtDesc = 'EXPIRES_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RoleNameAsc = 'ROLE_NAME_ASC',
  RoleNameDesc = 'ROLE_NAME_DESC',
  ServiceDefinitionIdAsc = 'SERVICE_DEFINITION_ID_ASC',
  ServiceDefinitionIdDesc = 'SERVICE_DEFINITION_ID_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedDateAsc = 'UPDATED_DATE_ASC',
  UpdatedDateDesc = 'UPDATED_DATE_DESC',
  UpdatedUserAsc = 'UPDATED_USER_ASC',
  UpdatedUserDesc = 'UPDATED_USER_DESC'
}

/** A filter to be used against Datetime fields. All fields are combined with a logical ‘and.’ */
export type DatetimeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Datetime']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Datetime']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Datetime']['input']>>;
};

export type DeleteAzureStorageContainerInput = {
  name: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  storageAccountName: Scalars['String']['input'];
};

export type DeleteAzureStorageContainerMutationPayload = {
  __typename?: 'DeleteAzureStorageContainerMutationPayload';
  container?: Maybe<DeletedAzureStorageContainer>;
};

/** All input for the `deleteContainerRegistryConnection` mutation. */
export type DeleteContainerRegistryConnectionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `ContainerRegistryConnection` mutation. */
export type DeleteContainerRegistryConnectionPayload = {
  __typename?: 'DeleteContainerRegistryConnectionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `ContainerRegistryConnection` that was deleted by this mutation. */
  containerRegistryConnection?: Maybe<ContainerRegistryConnection>;
  /** An edge for our `ContainerRegistryConnection`. May be used by Relay 1. */
  containerRegistryConnectionEdge?: Maybe<ContainerRegistryConnectionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our delete `ContainerRegistryConnection` mutation. */
export type DeleteContainerRegistryConnectionPayloadContainerRegistryConnectionEdgeArgs = {
  orderBy?: InputMaybe<Array<ContainerRegistryConnectionsOrderBy>>;
};

export type DeleteRmqUserPayload = {
  __typename?: 'DeleteRMQUserPayload';
  environmentId: Scalars['String']['output'];
  rmqUser: Scalars['String']['output'];
  rmqVHost: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/** All input for the `deleteServiceDefinition` mutation. */
export type DeleteServiceDefinitionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `ServiceDefinition` mutation. */
export type DeleteServiceDefinitionPayload = {
  __typename?: 'DeleteServiceDefinitionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ServiceDefinition` that was deleted by this mutation. */
  serviceDefinition?: Maybe<ServiceDefinition>;
  /** An edge for our `ServiceDefinition`. May be used by Relay 1. */
  serviceDefinitionEdge?: Maybe<ServiceDefinitionsEdge>;
};


/** The output of our delete `ServiceDefinition` mutation. */
export type DeleteServiceDefinitionPayloadServiceDefinitionEdgeArgs = {
  orderBy?: InputMaybe<Array<ServiceDefinitionsOrderBy>>;
};

/** All input for the `deleteServiceDeploymentManifest` mutation. */
export type DeleteServiceDeploymentManifestInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `ServiceDeploymentManifest` mutation. */
export type DeleteServiceDeploymentManifestPayload = {
  __typename?: 'DeleteServiceDeploymentManifestPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ServiceDefinition` that is related to this `ServiceDeploymentManifest`. */
  serviceDefinition?: Maybe<ServiceDefinition>;
  /** The `ServiceDeploymentManifest` that was deleted by this mutation. */
  serviceDeploymentManifest?: Maybe<ServiceDeploymentManifest>;
  /** An edge for our `ServiceDeploymentManifest`. May be used by Relay 1. */
  serviceDeploymentManifestEdge?: Maybe<ServiceDeploymentManifestsEdge>;
};


/** The output of our delete `ServiceDeploymentManifest` mutation. */
export type DeleteServiceDeploymentManifestPayloadServiceDeploymentManifestEdgeArgs = {
  orderBy?: InputMaybe<Array<ServiceDeploymentManifestsOrderBy>>;
};

/** All input for the `deleteServicePiletArtifact` mutation. */
export type DeleteServicePiletArtifactInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
};

/** The output of our delete `ServicePiletArtifact` mutation. */
export type DeleteServicePiletArtifactPayload = {
  __typename?: 'DeleteServicePiletArtifactPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ServiceDefinition` that is related to this `ServicePiletArtifact`. */
  serviceDefinition?: Maybe<ServiceDefinition>;
  /** The `ServicePiletArtifact` that was deleted by this mutation. */
  servicePiletArtifact?: Maybe<ServicePiletArtifact>;
  /** An edge for our `ServicePiletArtifact`. May be used by Relay 1. */
  servicePiletArtifactEdge?: Maybe<ServicePiletArtifactsEdge>;
};


/** The output of our delete `ServicePiletArtifact` mutation. */
export type DeleteServicePiletArtifactPayloadServicePiletArtifactEdgeArgs = {
  orderBy?: InputMaybe<Array<ServicePiletArtifactsOrderBy>>;
};

/** The input type to delete a set of stored secrets from a vault. */
export type DeleteVaultSecretsInput = {
  /** If selected, will delete all the secrets stored under the specified service-id, regardless of the value of 'secretsToDelete'. */
  deleteAllServiceSecrets?: InputMaybe<Scalars['Boolean']['input']>;
  /** Array of secret names to be deleted. */
  secretsToDelete?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The service-id where the secrets shall be deleted from. */
  serviceId: Scalars['String']['input'];
};

/** The return type containing an array of secrets names that were deleted. */
export type DeleteVaultSecretsPayload = {
  __typename?: 'DeleteVaultSecretsPayload';
  deletedSecrets?: Maybe<Array<Scalars['String']['output']>>;
};

export type DeletedAzureStorageContainer = {
  __typename?: 'DeletedAzureStorageContainer';
  name: Scalars['String']['output'];
};

/** A filter to be used against DeploymentConfigMap fields. All fields are combined with a logical ‘and.’ */
export type DeploymentConfigMapFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['DeploymentConfigMap']['input']>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['DeploymentConfigMap']['input']>;
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['DeploymentConfigMap']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['DeploymentConfigMap']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['DeploymentConfigMap']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['DeploymentConfigMap']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['DeploymentConfigMap']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['DeploymentConfigMap']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['DeploymentConfigMap']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['DeploymentConfigMap']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['DeploymentConfigMap']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['DeploymentConfigMap']['input']>>;
};

export type DisableStorageInput = {
  provider: ProviderType;
};

export type DisableStoragePayload = {
  __typename?: 'DisableStoragePayload';
  query?: Maybe<Query>;
  success: Scalars['Boolean']['output'];
};

export type DnsRecord = {
  __typename?: 'DnsRecord';
  configRefName: Scalars['String']['output'];
  createdDate: Scalars['Datetime']['output'];
  createdUser: Scalars['String']['output'];
  environmentId: Scalars['UUID']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  fqdn: Scalars['String']['output'];
  hostname: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  serviceDefinitionId: Scalars['UUID']['output'];
  status: ResourceStatus;
  tenantId: Scalars['UUID']['output'];
  updatedDate: Scalars['Datetime']['output'];
  updatedUser: Scalars['String']['output'];
};

/** A filter to be used against `DnsRecord` object types. All fields are combined with a logical ‘and.’ */
export type DnsRecordFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<DnsRecordFilter>>;
  /** Filter by the object’s `configRefName` field. */
  configRefName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdDate` field. */
  createdDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdUser` field. */
  createdUser?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `errorMessage` field. */
  errorMessage?: InputMaybe<StringFilter>;
  /** Filter by the object’s `fqdn` field. */
  fqdn?: InputMaybe<StringFilter>;
  /** Filter by the object’s `hostname` field. */
  hostname?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Negates the expression. */
  not?: InputMaybe<DnsRecordFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<DnsRecordFilter>>;
  /** Filter by the object’s `serviceDefinitionId` field. */
  serviceDefinitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<ResourceStatusFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<StringFilter>;
};

/** A connection to a list of `DnsRecord` values. */
export type DnsRecordsConnection = {
  __typename?: 'DnsRecordsConnection';
  /** A list of edges which contains the `DnsRecord` and cursor to aid in pagination. */
  edges: Array<DnsRecordsEdge>;
  /** A list of `DnsRecord` objects. */
  nodes: Array<DnsRecord>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `DnsRecord` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `DnsRecord` edge in the connection. */
export type DnsRecordsEdge = {
  __typename?: 'DnsRecordsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `DnsRecord` at the end of the edge. */
  node: DnsRecord;
};

export type EnableStorageInput = {
  provider: ProviderType;
};

export type EnableStoragePayload = {
  __typename?: 'EnableStoragePayload';
  query?: Maybe<Query>;
  success: Scalars['Boolean']['output'];
};

/** Exposes all error codes and messages for errors that a service requests can throw. In some cases, messages that are actually thrown can be different, since they can include more details or a single code can used for different errors of the same type. */
export enum ErrorCodesEnum {
  /** Access Token has expired. */
  AccessTokenExpired = 'ACCESS_TOKEN_EXPIRED',
  /** Access Token is invalid */
  AccessTokenInvalid = 'ACCESS_TOKEN_INVALID',
  /** Access Token is not provided */
  AccessTokenRequired = 'ACCESS_TOKEN_REQUIRED',
  /** Access token verification failed */
  AccessTokenVerificationFailed = 'ACCESS_TOKEN_VERIFICATION_FAILED',
  /** The assertion check for the identifier %s failed. */
  AssertionFailed = 'ASSERTION_FAILED',
  /** Authenticated End User not found. */
  AuthenticatedEndUserNotFound = 'AUTHENTICATED_END_USER_NOT_FOUND',
  /** Authenticated Management Subject not found. */
  AuthenticatedManagementSubjectNotFound = 'AUTHENTICATED_MANAGEMENT_SUBJECT_NOT_FOUND',
  /** A Permission Definition or an EndUserAuthorizationConfig was not found to be passed into Postgraphile build options. This is a development time issue. */
  AuthorizationOptionsMisconfigured = 'AUTHORIZATION_OPTIONS_MISCONFIGURED',
  /** Auth config is invalid. */
  AuthConfigInvalid = 'AUTH_CONFIG_INVALID',
  /** Deleting axinom-owned records are not allowed. */
  AxinomOwnedDeleteNotAllowed = 'AXINOM_OWNED_DELETE_NOT_ALLOWED',
  /** The service definition metadata is invalid. Please contact Axinom to resolve this issue. */
  AxinomServiceDefinitionNotFound = 'AXINOM_SERVICE_DEFINITION_NOT_FOUND',
  /** Error occurred trying to retrieve RabbitMQ Connection information from the RMQ Broker. */
  CannotConnectToRmqBroker = 'CANNOT_CONNECT_TO_RMQ_BROKER',
  /** %s %s can only be invoked using a Managed Service Account. */
  CannotInvokeMutation = 'CANNOT_INVOKE_MUTATION',
  /** Unable resolve DNS records due to data mismatch. Please contact Axinom Support. */
  CannotResolveDns = 'CANNOT_RESOLVE_DNS',
  /** Error while validating the ConfigMap. */
  ConfigMapValidationError = 'CONFIG_MAP_VALIDATION_ERROR',
  /** The value for configMap does not match its schema. */
  ConfigValueSchemaMismatch = 'CONFIG_VALUE_SCHEMA_MISMATCH',
  /** This session is not authorized for a database connection. */
  ConnectionNotAuthorized = 'CONNECTION_NOT_AUTHORIZED',
  /** There was an authentication error during connecting to the container registry. Please ensure the configured credentials are correct. */
  ContainerRegistryConnectionAuthError = 'CONTAINER_REGISTRY_CONNECTION_AUTH_ERROR',
  /** The requested image tag does not exist. Please ensure the image tag exists in the configured registry/repository and retry. */
  ContainerRegistryImageTagNotFound = 'CONTAINER_REGISTRY_IMAGE_TAG_NOT_FOUND',
  /** There was an error during connecting to the container registry. */
  ContainerRegistryNetworkError = 'CONTAINER_REGISTRY_NETWORK_ERROR',
  /** A container registry is not configured. Please configure it and try again. */
  ContainerRegistryNotConfigured = 'CONTAINER_REGISTRY_NOT_CONFIGURED',
  /** The requested repository [%s] does not exist in the container registry, or the configured credentials do not have read-only access to it. Please check them and try again. */
  ContainerRegistryRepositoryNotAccessible = 'CONTAINER_REGISTRY_REPOSITORY_NOT_ACCESSIBLE',
  /** The container registry responded with an unknown error. Please try again in a while. If the problem persists, please contact Axinom Support. */
  ContainerRegistryUnknownError = 'CONTAINER_REGISTRY_UNKNOWN_ERROR',
  /** The Service ID cannot start with 'ax-' nor 'axinom-', as they are reserved for Axinom-owned service definitions. */
  CustomizableServiceDefCannotStartWithAx = 'CUSTOMIZABLE_SERVICE_DEF_CANNOT_START_WITH_AX',
  /** Database access is not enabled for the service [%s]. */
  DatabaseAccessNotEnabled = 'DATABASE_ACCESS_NOT_ENABLED',
  /** Database configuration missing for the database created for Service Definition ID [%s]. Please contact Axinom Support. */
  DatabaseConfigMissing = 'DATABASE_CONFIG_MISSING',
  /** Finalzing Database resource is not allowed. */
  DatabaseFinalizeNotAllowed = 'DATABASE_FINALIZE_NOT_ALLOWED',
  /** A database operation has failed because of a lock timeout. */
  DatabaseLockTimeoutError = 'DATABASE_LOCK_TIMEOUT_ERROR',
  /** Database is not in READY state for Service Definition ID [%s]. Cannot proceed with deployment. */
  DatabaseNotReady = 'DATABASE_NOT_READY',
  /** An authorization database error has occurred. The user might not have enough permissions. */
  DatabasePermissionsCheckFailed = 'DATABASE_PERMISSIONS_CHECK_FAILED',
  /** Updating Database resource is not allowed. */
  DatabaseUpdateNotAllowed = 'DATABASE_UPDATE_NOT_ALLOWED',
  /** Database User Accounts for Service Definition ID [%s] has not been properly created. Please contact Axinom support. */
  DatabaseUserAccCreateError = 'DATABASE_USER_ACC_CREATE_ERROR',
  /** An expected and handled database constraint error has occurred. The actual message will have more information. */
  DatabaseValidationFailed = 'DATABASE_VALIDATION_FAILED',
  /** Database record not found for Service Definition ID [%s]. Cannot proceed with deployment. */
  DbRecNotFoundInServiceDef = 'DB_REC_NOT_FOUND_IN_SERVICE_DEF',
  /** Database to be deleted not found. */
  DeleteDatabaseNotFound = 'DELETE_DATABASE_NOT_FOUND',
  /** The deployment manifest depends on the DNS Record of another service, and it does not exist yet. Please ensure that the dependent service is deployed successfully. */
  DependentDnsNotExist = 'DEPENDENT_DNS_NOT_EXIST',
  /** The specified deployment is already undeployed. */
  DeploymentAlreadyUndeployed = 'DEPLOYMENT_ALREADY_UNDEPLOYED',
  /** There already exists a deployment in state [%s]. Please wait until it finishes. */
  DeploymentInPendingState = 'DEPLOYMENT_IN_PENDING_STATE',
  /** The deployment has a pending operation. Please wait until it is finished. */
  DeploymentInProgress = 'DEPLOYMENT_IN_PROGRESS',
  /** No Service Deployment Manifest was found for ID [%s]. */
  DeploymentManifestNotFound = 'DEPLOYMENT_MANIFEST_NOT_FOUND',
  /** No Service Definition found connected to the Service Deployment Manifest. */
  DeploymentManifestServiceDefNotFound = 'DEPLOYMENT_MANIFEST_SERVICE_DEF_NOT_FOUND',
  /** There exists newer deployments for the service. Please retry the action on the latest deployment. */
  DeploymentNotActive = 'DEPLOYMENT_NOT_ACTIVE',
  /** The specified deployment does not exist. Please ensure it already exists. */
  DeploymentNotFound = 'DEPLOYMENT_NOT_FOUND',
  /** DNS Record not found for Service Definition ID [%s] with name [%s]. Cannot proceed with deployment. */
  DnsRecordNotFound = 'DNS_RECORD_NOT_FOUND',
  /** DNS Record with name [%s] is not in READY state. Cannot proceed with deployment. */
  DnsRecordNotReady = 'DNS_RECORD_NOT_READY',
  /** Updating DNS records is not allowed. */
  DnsRecordUpdateNotAllowed = 'DNS_RECORD_UPDATE_NOT_ALLOWED',
  /** Ports section contains duplicate port names/numbers. */
  DuplicatePorts = 'DUPLICATE_PORTS',
  /** Service Accounts contain duplicate names. */
  DuplicateServiceAccountNames = 'DUPLICATE_SERVICE_ACCOUNT_NAMES',
  /** Error while deleting secrets. */
  ErrorDeletingSecrets = 'ERROR_DELETING_SECRETS',
  /** Error while retrieving secrets. */
  ErrorRetrievingSecrets = 'ERROR_RETRIEVING_SECRETS',
  /** Error while saving secrets. */
  ErrorSavingSecrets = 'ERROR_SAVING_SECRETS',
  /** This is a wrapper error for the original unhandled error of unsupported type. */
  ErrorWrapper = 'ERROR_WRAPPER',
  /** [%s] is only available for Managed Service Accounts, Service Accounts and Impersonated User Accounts */
  FieldOrOperationNotAvailable = 'FIELD_OR_OPERATION_NOT_AVAILABLE',
  /** A GraphQL validation error has occurred. Please make sure that the GraphQL request is made with correct syntax or parameters. */
  GraphqlValidationFailed = 'GRAPHQL_VALIDATION_FAILED',
  /** The Identity service is not accessible. Please contact Axinom support. */
  IdentityServiceNotAccessible = 'IDENTITY_SERVICE_NOT_ACCESSIBLE',
  /** An unhandled and unexpected error has occurred. Please contact the service support. */
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  /** Invalid secret names found. */
  InvalidSecretNamesFound = 'INVALID_SECRET_NAMES_FOUND',
  /** Error occurred while trying to fetch signing keys from the JWKS endpoint for the Tenant/Environment/Application. */
  JwksError = 'JWKS_ERROR',
  /** Passed JWT is not a Mosaic End-User Token. Cannot be verified. */
  JwtIsNotMosaicToken = 'JWT_IS_NOT_MOSAIC_TOKEN',
  /** This operation is currently not available due to ongoing infrastructure maintenance. Please contact Axinom Support for further information. */
  K8SApiMutationsBlocked = 'K8S_API_MUTATIONS_BLOCKED',
  /** Malformed access token received */
  MalformedToken = 'MALFORMED_TOKEN',
  /** The token is not an Authenticated End-User */
  NotAuthenticatedEndUser = 'NOT_AUTHENTICATED_END_USER',
  /** The object is not a AuthenticatedManagementSubject */
  NotAuthenticatedManagementSubject = 'NOT_AUTHENTICATED_MANAGEMENT_SUBJECT',
  /** The object is not a AuthenticatedRequest */
  NotAuthenticatedRequest = 'NOT_AUTHENTICATED_REQUEST',
  /** The token is not an End-User Application */
  NotEndUserApplication = 'NOT_END_USER_APPLICATION',
  /** The object is not an EndUserAuthenticationContext */
  NotEndUserAuthenticationContext = 'NOT_END_USER_AUTHENTICATION_CONTEXT',
  /** The object is not a GenericAuthenticatedSubject */
  NotGenericAuthenticatedSubject = 'NOT_GENERIC_AUTHENTICATED_SUBJECT',
  /** The object is not a ManagementAuthenticationContext */
  NotManagementAuthenticationContext = 'NOT_MANAGEMENT_AUTHENTICATION_CONTEXT',
  /** There is no active deployment for the selected service. */
  NoActiveDeployment = 'NO_ACTIVE_DEPLOYMENT',
  /** The service [%s] has no database that is ready. */
  NoDatabaseForService = 'NO_DATABASE_FOR_SERVICE',
  /** A caught error does not contain a error code. */
  NoErrorCodeFound = 'NO_ERROR_CODE_FOUND',
  /** The %s is missing required properties: %s. */
  ObjectIsMissingProperties = 'OBJECT_IS_MISSING_PROPERTIES',
  /** The Object Storage does not exist. */
  ObjectStorageDoesNotExist = 'OBJECT_STORAGE_DOES_NOT_EXIST',
  /** Error while activating the pilet [%s@%s]. */
  PiletActivateError = 'PILET_ACTIVATE_ERROR',
  /** Error while parsing the Pilet Artifact. */
  PiletArtifactParseError = 'PILET_ARTIFACT_PARSE_ERROR',
  /** Error while assigning Axinom owned pilet [%s@%s]. */
  PiletAssignmentError = 'PILET_ASSIGNMENT_ERROR',
  /** Error while deactivating the pilet [%s@%s]. */
  PiletDeactivateError = 'PILET_DEACTIVATE_ERROR',
  /** The uploaded file must be a .tgz file. */
  PiletNotTgz = 'PILET_NOT_TGZ',
  /** Cannot find a valid package.json in the uploaded pilet. The packaged pilet must have a package.json file 'name' & 'version' properties. */
  PiletPackageJsonNotFound = 'PILET_PACKAGE_JSON_NOT_FOUND',
  /** Error while publishing the pilet. */
  PiletPublishError = 'PILET_PUBLISH_ERROR',
  /** Error while un-assigning Axinom owned pilet [%s@%s]. */
  PiletUnassignError = 'PILET_UNASSIGN_ERROR',
  /** Error while unpublishing the pilet. */
  PiletUnpublishError = 'PILET_UNPUBLISH_ERROR',
  /** This environment has %s pods in use. The maximum number of pods allowed for this environment is %s. Please contact Axinom Support to increase the number of maximum pods allowed. */
  PodLimitExceeded = 'POD_LIMIT_EXCEEDED',
  /** An unhandled exception occurred while making a request to configure/clean up the RabbitMQ %s. Please contact Axinom support. */
  RequestErrorToRmq = 'REQUEST_ERROR_TO_RMQ',
  /** An error has occurred during resource creation and the deployment was not processed. Please check the deployment logs for details. */
  ResourceCreationError = 'RESOURCE_CREATION_ERROR',
  /** Deleting RMQ Connections resource is not allowed. */
  RmqConnectionDeleteNotAllowed = 'RMQ_CONNECTION_DELETE_NOT_ALLOWED',
  /** Finalizing up RMQ Connections resource is not allowed. */
  RmqConnectionFinalizeNotAllowed = 'RMQ_CONNECTION_FINALIZE_NOT_ALLOWED',
  /** RMQ Connection not found to be used with Hosting Service for Environment [%s]. Cannot proceed with deployment. */
  RmqConnectionNotFound = 'RMQ_CONNECTION_NOT_FOUND',
  /** Updating RMQ Connections resource is not allowed. */
  RmqConnectionUpdateNotAllowed = 'RMQ_CONNECTION_UPDATE_NOT_ALLOWED',
  /** Error occurred trying to setup environment messaging. */
  RmqSetupError = 'RMQ_SETUP_ERROR',
  /** Error occurred while trying to create a new RabbitMQ User. */
  RmqUserCreationError = 'RMQ_USER_CREATION_ERROR',
  /** RabbitMQ User does not exist. */
  RmqUserDoesNotExist = 'RMQ_USER_DOES_NOT_EXIST',
  /** The database role for this session could not be created. */
  RoleProvisioningFailed = 'ROLE_PROVISIONING_FAILED',
  /** The Managed Service Account must be scoped for a specific environment. */
  SaNotScopedToEnv = 'SA_NOT_SCOPED_TO_ENV',
  /** SDU Error */
  SduError = 'SDU_ERROR',
  /** Secrets array cannot be empty. */
  SecretsArrayEmpty = 'SECRETS_ARRAY_EMPTY',
  /** The requested secret name does not exist for the environment. Please check the request parameters and try again. */
  SecretDoesNotExist = 'SECRET_DOES_NOT_EXIST',
  /** %s was not found in Vault. Please contact Axinom Support. */
  SecretNotFoundInVault = 'SECRET_NOT_FOUND_IN_VAULT',
  /** Service account %s does not exist for Service Definition ID [%s]. */
  ServiceAccountNotFound = 'SERVICE_ACCOUNT_NOT_FOUND',
  /** An error occurred while updating a Service Account. */
  ServiceAccountUpdateError = 'SERVICE_ACCOUNT_UPDATE_ERROR',
  /** No Service Definition was found for ID [%s]. */
  ServiceDefinitionNotFound = 'SERVICE_DEFINITION_NOT_FOUND',
  /** No Service Definition was found for Service ID [%s]. */
  ServiceDefinitionNotFoundForServiceId = 'SERVICE_DEFINITION_NOT_FOUND_FOR_SERVICE_ID',
  /** Service Definition does not exist. */
  ServiceDefDoesNotExist = 'SERVICE_DEF_DOES_NOT_EXIST',
  /** Authenticate service manager before call methods. */
  ServiceManagerNotAuthenticated = 'SERVICE_MANAGER_NOT_AUTHENTICATED',
  /** The %s is not enabled for the environment. */
  ServiceNotEnabledForEnv = 'SERVICE_NOT_ENABLED_FOR_ENV',
  /** A service with the ID [%s] was not found. */
  ServiceNotFound = 'SERVICE_NOT_FOUND',
  /** The database access session [%s] has expired. */
  SessionExpired = 'SESSION_EXPIRED',
  /** The maximum number of concurrent database access sessions has been reached. */
  SessionLimitReached = 'SESSION_LIMIT_REACHED',
  /** A database access session with the ID [%s] was not found. */
  SessionNotFound = 'SESSION_NOT_FOUND',
  /** Could not find a matching signing key to verify the access token. The signing key used to create the token may have been revoked or the Tenant/Environment/Application configuration is erroneous. */
  SigningKeyNotFound = 'SIGNING_KEY_NOT_FOUND',
  /** An application startup error has occurred. The actual message will have more information. */
  StartupError = 'STARTUP_ERROR',
  /** Storage is disabled or pending creation. */
  StorageDisabledOrPending = 'STORAGE_DISABLED_OR_PENDING',
  /** User is authenticated, but subject information was not found. Please contact Axinom Support. */
  SubjectNotFound = 'SUBJECT_NOT_FOUND',
  /** The length of port name and Service ID combined cannot exceed 37 characters. */
  TooLongPortsName = 'TOO_LONG_PORTS_NAME',
  /** Service Accounts contains name longer than 15 characters: [%s] */
  TooLongServiceAccountsName = 'TOO_LONG_SERVICE_ACCOUNTS_NAME',
  /** The subject has no permissions. */
  Unauthorized = 'UNAUTHORIZED',
  /** Unexpected action for RMQ resource at %s. */
  UnexpectedActionRmq = 'UNEXPECTED_ACTION_RMQ',
  /** Unexpected null or undefined value received. */
  UnexpectedNullUndefined = 'UNEXPECTED_NULL_UNDEFINED',
  /** An unhandled error occurred while making requests through Axios. */
  UnhandledAxiosError = 'UNHANDLED_AXIOS_ERROR',
  /** An unhandled database-related error has occurred. Please contact the service support. */
  UnhandledDatabaseError = 'UNHANDLED_DATABASE_ERROR',
  /** An unhandled error has occurred. Please contact the service support. */
  UnhandledError = 'UNHANDLED_ERROR',
  /** Attempt to create or update an element failed, as it would have resulted in a duplicate element. */
  UniqueConstraintError = 'UNIQUE_CONSTRAINT_ERROR',
  /** Unknown env placeholder key [%s]. Cannot resolve. */
  UnknownEnvPlaceholder = 'UNKNOWN_ENV_PLACEHOLDER',
  /** Unknown property [%s] found in %s config. Cannot proceed with deployment. */
  UnknownPropertyInConfig = 'UNKNOWN_PROPERTY_IN_CONFIG',
  /** %s with ID [%s] is used in deployment [%s]. */
  UsedInDeployment = 'USED_IN_DEPLOYMENT',
  /** User is not authorized to access the operation. */
  UserNotAuthorized = 'USER_NOT_AUTHORIZED',
  /** The User service is not accessible. Please contact Axinom support. */
  UserServiceNotAccessible = 'USER_SERVICE_NOT_ACCESSIBLE',
  /** The %s is not an object. */
  ValueIsNotObject = 'VALUE_IS_NOT_OBJECT',
  /** Websocket not found in ExtendedGraphQLContext. This is a development time issue. A reference to the websocket must be included in Postgraphile build options. */
  WebsocketNotFound = 'WEBSOCKET_NOT_FOUND'
}

/** Input for generating a SAS token for an Azure Storage Container */
export type GenerateAzureStorageContainerSasTokenInput = {
  /** Name of the storage storage container */
  containerName: Scalars['String']['input'];
  /**
   * Permissions to be granted to the SAS token
   * i.e. "list", "read", "write", "delete", "add", "create"
   */
  permissions: Array<Scalars['String']['input']>;
  /** Name of the storage account */
  storageAccountName: Scalars['String']['input'];
  /** The time at which the SAS becomes valid. Default is the current time. */
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  /** The time at which the SAS becomes invalid. */
  validUntil: Scalars['Date']['input'];
};

/** Payload containing a SAS token for an Azure Storage Container */
export type GenerateAzureStorageContainerSasTokenMutationPayload = {
  __typename?: 'GenerateAzureStorageContainerSASTokenMutationPayload';
  sasTokenParams: Scalars['String']['output'];
  sasTokenUri: Scalars['String']['output'];
};

export type HostingPlan = {
  __typename?: 'HostingPlan';
  createdDate: Scalars['Datetime']['output'];
  createdUser: Scalars['String']['output'];
  defaultLimitPods: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `ServiceConfiguration`. */
  serviceConfigurations: ServiceConfigurationsConnection;
  updatedDate: Scalars['Datetime']['output'];
  updatedUser: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `VmSpecification`. */
  vmSpecifications: VmSpecificationsConnection;
};


export type HostingPlanServiceConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ServiceConfigurationCondition>;
  filter?: InputMaybe<ServiceConfigurationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceConfigurationsOrderBy>>;
};


export type HostingPlanVmSpecificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VmSpecificationCondition>;
  filter?: InputMaybe<VmSpecificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VmSpecificationsOrderBy>>;
};

/**
 * A condition to be used against `HostingPlan` object types. All fields are tested
 * for equality and combined with a logical ‘and.’
 */
export type HostingPlanCondition = {
  /** Checks for equality with the object’s `createdDate` field. */
  createdDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdUser` field. */
  createdUser?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `defaultLimitPods` field. */
  defaultLimitPods?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `HostingPlan` object types. All fields are combined with a logical ‘and.’ */
export type HostingPlanFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<HostingPlanFilter>>;
  /** Filter by the object’s `createdDate` field. */
  createdDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdUser` field. */
  createdUser?: InputMaybe<StringFilter>;
  /** Filter by the object’s `defaultLimitPods` field. */
  defaultLimitPods?: InputMaybe<IntFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<StringFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<HostingPlanFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<HostingPlanFilter>>;
  /** Filter by the object’s `serviceConfigurations` relation. */
  serviceConfigurations?: InputMaybe<HostingPlanToManyServiceConfigurationFilter>;
  /** Some related `serviceConfigurations` exist. */
  serviceConfigurationsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<StringFilter>;
  /** Filter by the object’s `vmSpecifications` relation. */
  vmSpecifications?: InputMaybe<HostingPlanToManyVmSpecificationFilter>;
  /** Some related `vmSpecifications` exist. */
  vmSpecificationsExist?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A filter to be used against many `ServiceConfiguration` object types. All fields are combined with a logical ‘and.’ */
export type HostingPlanToManyServiceConfigurationFilter = {
  /** Every related `ServiceConfiguration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ServiceConfigurationFilter>;
  /** No related `ServiceConfiguration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ServiceConfigurationFilter>;
  /** Some related `ServiceConfiguration` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ServiceConfigurationFilter>;
};

/** A filter to be used against many `VmSpecification` object types. All fields are combined with a logical ‘and.’ */
export type HostingPlanToManyVmSpecificationFilter = {
  /** Every related `VmSpecification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<VmSpecificationFilter>;
  /** No related `VmSpecification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<VmSpecificationFilter>;
  /** Some related `VmSpecification` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<VmSpecificationFilter>;
};

/** A connection to a list of `HostingPlan` values. */
export type HostingPlansConnection = {
  __typename?: 'HostingPlansConnection';
  /** A list of edges which contains the `HostingPlan` and cursor to aid in pagination. */
  edges: Array<HostingPlansEdge>;
  /** A list of `HostingPlan` objects. */
  nodes: Array<HostingPlan>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `HostingPlan` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `HostingPlan` edge in the connection. */
export type HostingPlansEdge = {
  __typename?: 'HostingPlansEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `HostingPlan` at the end of the edge. */
  node: HostingPlan;
};

/** Methods to use when ordering `HostingPlan`. */
export enum HostingPlansOrderBy {
  CreatedDateAsc = 'CREATED_DATE_ASC',
  CreatedDateDesc = 'CREATED_DATE_DESC',
  CreatedUserAsc = 'CREATED_USER_ASC',
  CreatedUserDesc = 'CREATED_USER_DESC',
  DefaultLimitPodsAsc = 'DEFAULT_LIMIT_PODS_ASC',
  DefaultLimitPodsDesc = 'DEFAULT_LIMIT_PODS_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  UpdatedDateAsc = 'UPDATED_DATE_ASC',
  UpdatedDateDesc = 'UPDATED_DATE_DESC',
  UpdatedUserAsc = 'UPDATED_USER_ASC',
  UpdatedUserDesc = 'UPDATED_USER_DESC'
}

export type InitializeVhostPayload = {
  __typename?: 'InitializeVhostPayload';
  rmqVHost?: Maybe<Scalars['String']['output']>;
};

/**
 * Input Type for the initiateServiceDeployment mutation.
 * Expects:
 * - serviceDefinitionId
 * - containerImageVersion
 * - serviceDeploymentConfigurationId
 * - servicePiletArtifactIds
 */
export type InitiateServiceDeploymentInput = {
  containerImageVersion: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  serviceDefinitionId: Scalars['UUID']['input'];
  serviceDeploymentConfigurationId: Scalars['UUID']['input'];
  servicePiletArtifactIds: Array<Scalars['UUID']['input']>;
};

/** Response for initiateServiceDeployment mutation. */
export type InitiateServiceDeploymentPayload = {
  __typename?: 'InitiateServiceDeploymentPayload';
  name: Scalars['String']['output'];
  serviceDefinitionId: Scalars['UUID']['output'];
  serviceDeploymentId: Scalars['UUID']['output'];
  status: ResourceStatus;
};

/** Input Type for the initiateServiceRedeployment mutation. */
export type InitiateServiceRedeploymentInput = {
  serviceDeploymentId: Scalars['UUID']['input'];
};

/** Response for initiateServiceRedeployment mutation. */
export type InitiateServiceRedeploymentPayload = {
  __typename?: 'InitiateServiceRedeploymentPayload';
  serviceDefinitionId: Scalars['UUID']['output'];
  serviceDeploymentId: Scalars['UUID']['output'];
  status: ResourceStatus;
};

/**
 * Input Type for the initiateServiceUndeployment mutation.
 * Expects:
 * - serviceDeploymentId
 */
export type InitiateServiceUndeploymentInput = {
  serviceDeploymentId: Scalars['UUID']['input'];
};

/** Response for initiateServiceUndeployment mutation. */
export type InitiateServiceUndeploymentPayload = {
  __typename?: 'InitiateServiceUndeploymentPayload';
  serviceDefinitionId: Scalars['UUID']['output'];
  serviceDeploymentId: Scalars['UUID']['output'];
  status: ResourceStatus;
};

/** A filter to be used against Int fields. All fields are combined with a logical ‘and.’ */
export type IntFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['Int']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['Int']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['Int']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** A filter to be used against JSON fields. All fields are combined with a logical ‘and.’ */
export type JsonFilter = {
  /** Contained by the specified JSON. */
  containedBy?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains the specified JSON. */
  contains?: InputMaybe<Scalars['JSON']['input']>;
  /** Contains all of the specified keys. */
  containsAllKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains any of the specified keys. */
  containsAnyKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified key. */
  containsKey?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['JSON']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['JSON']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['JSON']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['JSON']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['JSON']['input']>>;
};

/** The root mutation type which contains root level fields which mutate data. */
export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Called by the database proxy service once per connection to authorize it. Fails
   * flatly if the session is unknown, closed, expired, or belongs to
   * another tenant or environment.
   */
  authorizeDatabaseAccessConnection: AuthorizeDatabaseAccessConnectionPayload;
  /**
   * Drops the session's database role and terminates its connections.
   * Idempotent, so the reconciliation worker and the CLI can both call it.
   */
  closeDatabaseAccessSession: CloseDatabaseAccessSessionPayload;
  /** Creates a single `AxinomServiceDefinition`. */
  createAxinomServiceDefinition?: Maybe<CreateAxinomServiceDefinitionPayload>;
  /** Creates a single `AxinomServiceDeploymentManifest`. */
  createAxinomServiceDeploymentManifest?: Maybe<CreateAxinomServiceDeploymentManifestPayload>;
  /**
   * Create a new Axinom Owned Pilet Artifact against a given Service Definition.
   * The name & packageVersion will be derived from the properties in the package.json
   * in the packed pilet.
   */
  createAxinomServicePiletArtifact: CreateAxinomServicePiletArtifactPayload;
  createAzureStorageContainer?: Maybe<CreateAzureStorageContainerMutationPayload>;
  /** Creates a single `ContainerRegistryConnection`. */
  createContainerRegistryConnection?: Maybe<CreateContainerRegistryConnectionPayload>;
  /** Creates a single `ServiceDefinition`. */
  createServiceDefinition?: Maybe<CreateServiceDefinitionPayload>;
  /** Create a new Service Deployment Manifest against a given Service ID. */
  createServiceDeploymentManifest: CreateServiceDeploymentManifestPayload;
  /**
   * Create a new Pilet Artifact against a given Service Definition.
   * The name & packageVersion will be derived from the properties in the package.json
   * in the packed pilet.
   */
  createServicePiletArtifact: CreateServicePiletArtifactPayload;
  deleteAzureStorageContainer?: Maybe<DeleteAzureStorageContainerMutationPayload>;
  /** Deletes a single `ContainerRegistryConnection` using a unique key. */
  deleteContainerRegistryConnection?: Maybe<DeleteContainerRegistryConnectionPayload>;
  /** Delete the RabbitMQ user for the environment. */
  deleteRMQUser?: Maybe<DeleteRmqUserPayload>;
  /** Deletes a single `ServiceDefinition` using a unique key. */
  deleteServiceDefinition?: Maybe<DeleteServiceDefinitionPayload>;
  /** Deletes a single `ServiceDeploymentManifest` using a unique key. */
  deleteServiceDeploymentManifest?: Maybe<DeleteServiceDeploymentManifestPayload>;
  /** Deletes a single `ServicePiletArtifact` using a unique key. */
  deleteServicePiletArtifact?: Maybe<DeleteServicePiletArtifactPayload>;
  /** This mutation can be used to delete a set of secrets in a tenant/environment/service specific vault. */
  deleteVaultSecrets?: Maybe<DeleteVaultSecretsPayload>;
  disableStorage?: Maybe<DisableStoragePayload>;
  enableStorage?: Maybe<EnableStoragePayload>;
  generateAzureStorageContainerSASToken?: Maybe<GenerateAzureStorageContainerSasTokenMutationPayload>;
  /** Initialize RabbitMQ Vhost for the environment. */
  initializeVhost?: Maybe<InitializeVhostPayload>;
  /** Deploy specified version of the customizable service */
  initiateServiceDeployment: InitiateServiceDeploymentPayload;
  /**
   * Executes the deploy action with the exact same configuration as the specified input deployment.
   *
   * This can be used to redeploy a deployment that failed due to a transient error and will only allow
   * to retry deployments that are ACTIVE = TRUE.
   */
  initiateServiceRedeployment: InitiateServiceRedeploymentPayload;
  /** Deploy specified version of the customizable service */
  initiateServiceUndeployment: InitiateServiceUndeploymentPayload;
  /** Open a time-limited direct database access session for a customizable service. */
  openDatabaseAccessSession: OpenDatabaseAccessSessionPayload;
  regenerateObjectStorageConnectionString?: Maybe<RegenerateObjectStorageConnectionStringMutationPayload>;
  /**
   * Enable or disable direct database access for a customizable service.
   * Enabling grants access for DATABASE_ACCESS_FLAG_TTL_HOURS from now,
   * after which it lapses on its own. Disabling clears the flag, which
   * takes effect immediately; the sessions still open against the service
   * are then closed in the background.
   */
  setDatabaseAccess: SetDatabaseAccessPayload;
  /** Set expiration data for customizable service */
  setServiceExpirationDate: SetServiceExpirationDatePayload;
  /**
   * Setup a RabbitMQ user for the environment. If a user already exists
   * it will be overridden.
   */
  setupRMQUser?: Maybe<SetupRmqUserPayload>;
  /**
   * This mutation can be used to store a set of secrets in a tenant/environment/service specific vault.
   * If the same secret name already exists, the value will be stored under a new version of the same secret name.
   */
  storeVaultSecrets?: Maybe<StoreVaultSecretsPayload>;
  updateAzureStorageContainer?: Maybe<UpdateAzureStorageContainerMutationPayload>;
  /** Updates a single `ContainerRegistryConnection` using a unique key and a patch. */
  updateContainerRegistryConnection?: Maybe<UpdateContainerRegistryConnectionPayload>;
  /** Updates a single `ServiceDefinition` using a unique key and a patch. */
  updateServiceDefinition?: Maybe<UpdateServiceDefinitionPayload>;
  /** Updates a single `ServiceDeployment` using a unique key and a patch. */
  updateServiceDeployment?: Maybe<UpdateServiceDeploymentPayload>;
  /** Updates a single `ServiceDeploymentManifest` using a unique key and a patch. */
  updateServiceDeploymentManifest?: Maybe<UpdateServiceDeploymentManifestPayload>;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationAuthorizeDatabaseAccessConnectionArgs = {
  input: AuthorizeDatabaseAccessConnectionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCloseDatabaseAccessSessionArgs = {
  input: CloseDatabaseAccessSessionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAxinomServiceDefinitionArgs = {
  input: CreateAxinomServiceDefinitionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAxinomServiceDeploymentManifestArgs = {
  input: CreateAxinomServiceDeploymentManifestInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAxinomServicePiletArtifactArgs = {
  input: CreateAxinomServicePiletArtifactInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateAzureStorageContainerArgs = {
  input: CreateAzureStorageContainerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateContainerRegistryConnectionArgs = {
  input: CreateContainerRegistryConnectionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateServiceDefinitionArgs = {
  input: CreateServiceDefinitionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateServiceDeploymentManifestArgs = {
  input: CreateServiceDeploymentManifestInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationCreateServicePiletArtifactArgs = {
  input: CreateServicePiletArtifactInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteAzureStorageContainerArgs = {
  input: DeleteAzureStorageContainerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteContainerRegistryConnectionArgs = {
  input: DeleteContainerRegistryConnectionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteServiceDefinitionArgs = {
  input: DeleteServiceDefinitionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteServiceDeploymentManifestArgs = {
  input: DeleteServiceDeploymentManifestInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteServicePiletArtifactArgs = {
  input: DeleteServicePiletArtifactInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDeleteVaultSecretsArgs = {
  input: DeleteVaultSecretsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationDisableStorageArgs = {
  input: DisableStorageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationEnableStorageArgs = {
  input: EnableStorageInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationGenerateAzureStorageContainerSasTokenArgs = {
  input: GenerateAzureStorageContainerSasTokenInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationInitiateServiceDeploymentArgs = {
  input: InitiateServiceDeploymentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationInitiateServiceRedeploymentArgs = {
  input: InitiateServiceRedeploymentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationInitiateServiceUndeploymentArgs = {
  input: InitiateServiceUndeploymentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationOpenDatabaseAccessSessionArgs = {
  input: OpenDatabaseAccessSessionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationRegenerateObjectStorageConnectionStringArgs = {
  input: RegenerateObjectStorageConnectionStringInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetDatabaseAccessArgs = {
  input: SetDatabaseAccessInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationSetServiceExpirationDateArgs = {
  input: SetServiceExpirationDateInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationStoreVaultSecretsArgs = {
  input: StoreVaultSecretsInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateAzureStorageContainerArgs = {
  input: UpdateAzureStorageContainerInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateContainerRegistryConnectionArgs = {
  input: UpdateContainerRegistryConnectionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateServiceDefinitionArgs = {
  input: UpdateServiceDefinitionInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateServiceDeploymentArgs = {
  input: UpdateServiceDeploymentInput;
};


/** The root mutation type which contains root level fields which mutate data. */
export type MutationUpdateServiceDeploymentManifestArgs = {
  input: UpdateServiceDeploymentManifestInput;
};

export type ObjectStorage = {
  __typename?: 'ObjectStorage';
  azureConnectionString?: Maybe<Scalars['String']['output']>;
  azureStorageAccountKey?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['Datetime']['output'];
  createdUser: Scalars['String']['output'];
  environmentId: Scalars['UUID']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  provider: ProviderType;
  status: ResourceStatus;
  tenantId: Scalars['UUID']['output'];
  title: Scalars['String']['output'];
  updatedDate: Scalars['Datetime']['output'];
  updatedUser: Scalars['String']['output'];
};

/**
 * A condition to be used against `ObjectStorage` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ObjectStorageCondition = {
  /** Checks for equality with the object’s `azureConnectionString` field. */
  azureConnectionString?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdDate` field. */
  createdDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdUser` field. */
  createdUser?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `errorMessage` field. */
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `provider` field. */
  provider?: InputMaybe<ProviderType>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<ResourceStatus>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<Scalars['String']['input']>;
};

export type ObjectStorageDetailsQueryInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  storageAccountName: Scalars['String']['input'];
};

export type ObjectStorageDetailsQueryPayload = {
  __typename?: 'ObjectStorageDetailsQueryPayload';
  containerCount?: Maybe<Scalars['Int']['output']>;
  storageAccountConsumptionInBytes?: Maybe<Scalars['Float']['output']>;
};

/** A filter to be used against `ObjectStorage` object types. All fields are combined with a logical ‘and.’ */
export type ObjectStorageFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ObjectStorageFilter>>;
  /** Filter by the object’s `azureConnectionString` field. */
  azureConnectionString?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdDate` field. */
  createdDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdUser` field. */
  createdUser?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `errorMessage` field. */
  errorMessage?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ObjectStorageFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ObjectStorageFilter>>;
  /** Filter by the object’s `provider` field. */
  provider?: InputMaybe<ProviderTypeFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<ResourceStatusFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<StringFilter>;
};

export type ObjectStorageLog = {
  __typename?: 'ObjectStorageLog';
  createdDate: Scalars['Datetime']['output'];
  createdUser: Scalars['String']['output'];
  environmentId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  message: Scalars['JSON']['output'];
  messageType: Scalars['String']['output'];
  tenantId: Scalars['UUID']['output'];
  timestamp: Scalars['Datetime']['output'];
  updatedDate: Scalars['Datetime']['output'];
  updatedUser: Scalars['String']['output'];
};

/**
 * A condition to be used against `ObjectStorageLog` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ObjectStorageLogCondition = {
  /** Checks for equality with the object’s `createdDate` field. */
  createdDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdUser` field. */
  createdUser?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `message` field. */
  message?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `messageType` field. */
  messageType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ObjectStorageLog` object types. All fields are combined with a logical ‘and.’ */
export type ObjectStorageLogFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ObjectStorageLogFilter>>;
  /** Filter by the object’s `createdDate` field. */
  createdDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdUser` field. */
  createdUser?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `message` field. */
  message?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `messageType` field. */
  messageType?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ObjectStorageLogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ObjectStorageLogFilter>>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<StringFilter>;
};

export enum ObjectStorageLogSubscriptionEventKey {
  ObjectStorageLogChanged = 'OBJECT_STORAGE_LOG_CHANGED',
  ObjectStorageLogCreated = 'OBJECT_STORAGE_LOG_CREATED',
  ObjectStorageLogDeleted = 'OBJECT_STORAGE_LOG_DELETED'
}

export type ObjectStorageLogSubscriptionPayload = {
  __typename?: 'ObjectStorageLogSubscriptionPayload';
  /** @deprecated Use 'eventKey' instead. */
  event?: Maybe<Scalars['String']['output']>;
  eventKey?: Maybe<ObjectStorageLogSubscriptionEventKey>;
  id: Scalars['UUID']['output'];
  objectStorageLog?: Maybe<ObjectStorageLog>;
};

/** A connection to a list of `ObjectStorageLog` values. */
export type ObjectStorageLogsConnection = {
  __typename?: 'ObjectStorageLogsConnection';
  /** A list of edges which contains the `ObjectStorageLog` and cursor to aid in pagination. */
  edges: Array<ObjectStorageLogsEdge>;
  /** A list of `ObjectStorageLog` objects. */
  nodes: Array<ObjectStorageLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ObjectStorageLog` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ObjectStorageLog` edge in the connection. */
export type ObjectStorageLogsEdge = {
  __typename?: 'ObjectStorageLogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ObjectStorageLog` at the end of the edge. */
  node: ObjectStorageLog;
};

/** Methods to use when ordering `ObjectStorageLog`. */
export enum ObjectStorageLogsOrderBy {
  CreatedDateAsc = 'CREATED_DATE_ASC',
  CreatedDateDesc = 'CREATED_DATE_DESC',
  CreatedUserAsc = 'CREATED_USER_ASC',
  CreatedUserDesc = 'CREATED_USER_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  MessageAsc = 'MESSAGE_ASC',
  MessageDesc = 'MESSAGE_DESC',
  MessageTypeAsc = 'MESSAGE_TYPE_ASC',
  MessageTypeDesc = 'MESSAGE_TYPE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  TimestampAsc = 'TIMESTAMP_ASC',
  TimestampDesc = 'TIMESTAMP_DESC',
  UpdatedDateAsc = 'UPDATED_DATE_ASC',
  UpdatedDateDesc = 'UPDATED_DATE_DESC',
  UpdatedUserAsc = 'UPDATED_USER_ASC',
  UpdatedUserDesc = 'UPDATED_USER_DESC'
}

export enum ObjectStorageSubscriptionEventKey {
  ObjectStorageChanged = 'OBJECT_STORAGE_CHANGED',
  ObjectStorageCreated = 'OBJECT_STORAGE_CREATED',
  ObjectStorageDeleted = 'OBJECT_STORAGE_DELETED'
}

export type ObjectStorageSubscriptionPayload = {
  __typename?: 'ObjectStorageSubscriptionPayload';
  /** @deprecated Use 'eventKey' instead. */
  event?: Maybe<Scalars['String']['output']>;
  eventKey?: Maybe<ObjectStorageSubscriptionEventKey>;
  id: Scalars['UUID']['output'];
  objectStorage?: Maybe<ObjectStorage>;
};

/** A connection to a list of `ObjectStorage` values. */
export type ObjectStoragesConnection = {
  __typename?: 'ObjectStoragesConnection';
  /** A list of edges which contains the `ObjectStorage` and cursor to aid in pagination. */
  edges: Array<ObjectStoragesEdge>;
  /** A list of `ObjectStorage` objects. */
  nodes: Array<ObjectStorage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ObjectStorage` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ObjectStorage` edge in the connection. */
export type ObjectStoragesEdge = {
  __typename?: 'ObjectStoragesEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ObjectStorage` at the end of the edge. */
  node: ObjectStorage;
};

/** Methods to use when ordering `ObjectStorage`. */
export enum ObjectStoragesOrderBy {
  AzureConnectionStringAsc = 'AZURE_CONNECTION_STRING_ASC',
  AzureConnectionStringDesc = 'AZURE_CONNECTION_STRING_DESC',
  CreatedDateAsc = 'CREATED_DATE_ASC',
  CreatedDateDesc = 'CREATED_DATE_DESC',
  CreatedUserAsc = 'CREATED_USER_ASC',
  CreatedUserDesc = 'CREATED_USER_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  ErrorMessageAsc = 'ERROR_MESSAGE_ASC',
  ErrorMessageDesc = 'ERROR_MESSAGE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ProviderAsc = 'PROVIDER_ASC',
  ProviderDesc = 'PROVIDER_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  UpdatedDateAsc = 'UPDATED_DATE_ASC',
  UpdatedDateDesc = 'UPDATED_DATE_DESC',
  UpdatedUserAsc = 'UPDATED_USER_ASC',
  UpdatedUserDesc = 'UPDATED_USER_DESC'
}

/** Input Type for the openDatabaseAccessSession mutation. */
export type OpenDatabaseAccessSessionInput = {
  serviceId: Scalars['String']['input'];
  ttlMinutes?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Returned exactly once. The password is a real PostgreSQL credential minted
 * for this session alone and cannot be retrieved again.
 */
export type OpenDatabaseAccessSessionPayload = {
  __typename?: 'OpenDatabaseAccessSessionPayload';
  databaseName: Scalars['String']['output'];
  databaseProxyUrl: Scalars['String']['output'];
  expiresAt: Scalars['Datetime']['output'];
  password: Scalars['String']['output'];
  sessionId: Scalars['UUID']['output'];
  username: Scalars['String']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['Cursor']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['Cursor']['output']>;
};

export enum ProviderType {
  /** Azure */
  Azure = 'AZURE'
}

/** A filter to be used against ProviderType fields. All fields are combined with a logical ‘and.’ */
export type ProviderTypeFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ProviderType>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ProviderType>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ProviderType>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ProviderType>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ProviderType>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ProviderType>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ProviderType>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ProviderType>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ProviderType>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ProviderType>>;
};

/** The root query type which gives access points into the data universe. */
export type Query = {
  __typename?: 'Query';
  axinomServiceDefinition?: Maybe<AxinomServiceDefinition>;
  /** Reads and enables pagination through a set of `AxinomServiceDefinition`. */
  axinomServiceDefinitions?: Maybe<AxinomServiceDefinitionsConnection>;
  axinomServiceDeploymentManifest?: Maybe<AxinomServiceDeploymentManifest>;
  /** Reads and enables pagination through a set of `AxinomServiceDeploymentManifest`. */
  axinomServiceDeploymentManifests?: Maybe<AxinomServiceDeploymentManifestsConnection>;
  axinomServicePiletArtifact?: Maybe<AxinomServicePiletArtifact>;
  /** Reads and enables pagination through a set of `AxinomServicePiletArtifact`. */
  axinomServicePiletArtifacts?: Maybe<AxinomServicePiletArtifactsConnection>;
  azureStorageContainer?: Maybe<AzureStorageContainerQueryPayload>;
  azureStorageContainerSASTokenParams?: Maybe<AzureStorageContainerSasTokenParamsPayload>;
  azureStorageContainers?: Maybe<AzureStorageContainersQueryPayload>;
  containerRegistryConnection?: Maybe<ContainerRegistryConnection>;
  /** Reads and enables pagination through a set of `ContainerRegistryConnection`. */
  containerRegistryConnections?: Maybe<ContainerRegistryConnectionsConnection>;
  databaseAccessSession?: Maybe<DatabaseAccessSession>;
  /** Reads and enables pagination through a set of `DatabaseAccessSession`. */
  databaseAccessSessions?: Maybe<DatabaseAccessSessionsConnection>;
  hostingPlan?: Maybe<HostingPlan>;
  /** Reads and enables pagination through a set of `HostingPlan`. */
  hostingPlans?: Maybe<HostingPlansConnection>;
  objectStorage?: Maybe<ObjectStorage>;
  objectStorageDetails?: Maybe<ObjectStorageDetailsQueryPayload>;
  objectStorageLog?: Maybe<ObjectStorageLog>;
  /** Reads and enables pagination through a set of `ObjectStorageLog`. */
  objectStorageLogs?: Maybe<ObjectStorageLogsConnection>;
  /** Reads and enables pagination through a set of `ObjectStorage`. */
  objectStorages?: Maybe<ObjectStoragesConnection>;
  /**
   * Exposes the root query type nested one level down. This is helpful for Relay 1
   * which can only query top level fields if they are in a particular form.
   */
  query: Query;
  /** Query the RabbitMQ vhost and user details for the environment. */
  rmqConnection?: Maybe<RmqConnectionPayload>;
  serviceConfiguration?: Maybe<ServiceConfiguration>;
  /** Reads and enables pagination through a set of `ServiceConfiguration`. */
  serviceConfigurations?: Maybe<ServiceConfigurationsConnection>;
  serviceDefinition?: Maybe<ServiceDefinition>;
  serviceDefinitionByServiceId?: Maybe<ServiceDefinition>;
  /** Reads and enables pagination through a set of `ServiceDefinition`. */
  serviceDefinitions?: Maybe<ServiceDefinitionsConnection>;
  serviceDeployment?: Maybe<ServiceDeployment>;
  serviceDeploymentLog?: Maybe<ServiceDeploymentLog>;
  /** Reads and enables pagination through a set of `ServiceDeploymentLog`. */
  serviceDeploymentLogs?: Maybe<ServiceDeploymentLogsConnection>;
  serviceDeploymentManifest?: Maybe<ServiceDeploymentManifest>;
  /** Reads and enables pagination through a set of `ServiceDeploymentManifest`. */
  serviceDeploymentManifests?: Maybe<ServiceDeploymentManifestsConnection>;
  /** Reads and enables pagination through a set of `ServiceDeployment`. */
  serviceDeployments?: Maybe<ServiceDeploymentsConnection>;
  servicePiletArtifact?: Maybe<ServicePiletArtifact>;
  /** Reads and enables pagination through a set of `ServicePiletArtifact`. */
  servicePiletArtifacts?: Maybe<ServicePiletArtifactsConnection>;
  /**
   * Retrieve the runtime logs of a deployed service, across all of its
   * running replicas.
   */
  serviceRuntimeLogs?: Maybe<ServiceRuntimeLogsResult>;
  /** This query can be used to retrieve a set of secrets from a tenant/environment/service specific vault. */
  vaultSecrets?: Maybe<VaultSecretsPayload>;
  vmSpecification?: Maybe<VmSpecification>;
  /** Reads and enables pagination through a set of `VmSpecification`. */
  vmSpecifications?: Maybe<VmSpecificationsConnection>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAxinomServiceDefinitionArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAxinomServiceDefinitionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AxinomServiceDefinitionCondition>;
  filter?: InputMaybe<AxinomServiceDefinitionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AxinomServiceDefinitionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAxinomServiceDeploymentManifestArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAxinomServiceDeploymentManifestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AxinomServiceDeploymentManifestCondition>;
  filter?: InputMaybe<AxinomServiceDeploymentManifestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AxinomServiceDeploymentManifestsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAxinomServicePiletArtifactArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryAxinomServicePiletArtifactsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<AxinomServicePiletArtifactCondition>;
  filter?: InputMaybe<AxinomServicePiletArtifactFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AxinomServicePiletArtifactsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryAzureStorageContainerArgs = {
  input: AzureStorageContainerQueryInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryAzureStorageContainerSasTokenParamsArgs = {
  input: AzureStorageContainerSasTokenParamsInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryAzureStorageContainersArgs = {
  input: AzureStorageContainersQueryInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryContainerRegistryConnectionArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryContainerRegistryConnectionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ContainerRegistryConnectionCondition>;
  filter?: InputMaybe<ContainerRegistryConnectionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ContainerRegistryConnectionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryDatabaseAccessSessionArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryDatabaseAccessSessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DatabaseAccessSessionCondition>;
  filter?: InputMaybe<DatabaseAccessSessionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DatabaseAccessSessionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryHostingPlanArgs = {
  id: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryHostingPlansArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<HostingPlanCondition>;
  filter?: InputMaybe<HostingPlanFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<HostingPlansOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryObjectStorageArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryObjectStorageDetailsArgs = {
  input: ObjectStorageDetailsQueryInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryObjectStorageLogArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryObjectStorageLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ObjectStorageLogCondition>;
  filter?: InputMaybe<ObjectStorageLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectStorageLogsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryObjectStoragesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ObjectStorageCondition>;
  filter?: InputMaybe<ObjectStorageFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ObjectStoragesOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryServiceConfigurationArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryServiceConfigurationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ServiceConfigurationCondition>;
  filter?: InputMaybe<ServiceConfigurationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceConfigurationsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryServiceDefinitionArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryServiceDefinitionByServiceIdArgs = {
  environmentId: Scalars['UUID']['input'];
  serviceId: Scalars['String']['input'];
  tenantId: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryServiceDefinitionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ServiceDefinitionCondition>;
  filter?: InputMaybe<ServiceDefinitionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceDefinitionsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryServiceDeploymentArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryServiceDeploymentLogArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryServiceDeploymentLogsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ServiceDeploymentLogCondition>;
  filter?: InputMaybe<ServiceDeploymentLogFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceDeploymentLogsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryServiceDeploymentManifestArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryServiceDeploymentManifestsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ServiceDeploymentManifestCondition>;
  filter?: InputMaybe<ServiceDeploymentManifestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceDeploymentManifestsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryServiceDeploymentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ServiceDeploymentCondition>;
  filter?: InputMaybe<ServiceDeploymentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceDeploymentsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryServicePiletArtifactArgs = {
  id: Scalars['UUID']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryServicePiletArtifactsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ServicePiletArtifactCondition>;
  filter?: InputMaybe<ServicePiletArtifactFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServicePiletArtifactsOrderBy>>;
};


/** The root query type which gives access points into the data universe. */
export type QueryServiceRuntimeLogsArgs = {
  input: ServiceRuntimeLogsInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryVaultSecretsArgs = {
  input: VaultSecretsInput;
};


/** The root query type which gives access points into the data universe. */
export type QueryVmSpecificationArgs = {
  hostingPlanId: Scalars['String']['input'];
  vmSpecId: Scalars['String']['input'];
};


/** The root query type which gives access points into the data universe. */
export type QueryVmSpecificationsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<VmSpecificationCondition>;
  filter?: InputMaybe<VmSpecificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<VmSpecificationsOrderBy>>;
};

export type RmqConnectionPayload = {
  __typename?: 'RMQConnectionPayload';
  environmentId: Scalars['String']['output'];
  rmqHost: Scalars['String']['output'];
  rmqMgmtHost: Scalars['String']['output'];
  rmqMgmtPort: Scalars['String']['output'];
  rmqMgmtProtocol: Scalars['String']['output'];
  rmqPassword?: Maybe<Scalars['String']['output']>;
  rmqPort: Scalars['String']['output'];
  rmqProtocol: Scalars['String']['output'];
  rmqUser?: Maybe<Scalars['String']['output']>;
  rmqVHost?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['String']['output'];
};

export type RegenerateObjectStorageConnectionStringInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  provider: Scalars['String']['input'];
  storageAccountName: Scalars['String']['input'];
};

export type RegenerateObjectStorageConnectionStringMutationPayload = {
  __typename?: 'RegenerateObjectStorageConnectionStringMutationPayload';
  storageAccountConnectionString: Scalars['String']['output'];
};

export { ResourceStatus };

/** A filter to be used against ResourceStatus fields. All fields are combined with a logical ‘and.’ */
export type ResourceStatusFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<ResourceStatus>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<ResourceStatus>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<ResourceStatus>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<ResourceStatus>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<ResourceStatus>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<ResourceStatus>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<ResourceStatus>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<ResourceStatus>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<ResourceStatus>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<ResourceStatus>>;
};

/**
 * This GraphQL type is used when returning a stored secret
 * when retrieved by secret name.
 */
export type RetrievedVaultSecret = {
  __typename?: 'RetrievedVaultSecret';
  name: Scalars['String']['output'];
  secret: Scalars['String']['output'];
};

export type ServiceConfiguration = {
  __typename?: 'ServiceConfiguration';
  activeHostingPlan: Scalars['String']['output'];
  createdDate: Scalars['Datetime']['output'];
  createdUser: Scalars['String']['output'];
  environmentId: Scalars['UUID']['output'];
  environmentName: Scalars['String']['output'];
  /** Reads a single `HostingPlan` that is related to this `ServiceConfiguration`. */
  hostingPlan?: Maybe<HostingPlan>;
  id: Scalars['UUID']['output'];
  limitPods: Scalars['Int']['output'];
  tenantId: Scalars['UUID']['output'];
  tenantName: Scalars['String']['output'];
  updatedDate: Scalars['Datetime']['output'];
  updatedUser: Scalars['String']['output'];
};

/**
 * A condition to be used against `ServiceConfiguration` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ServiceConfigurationCondition = {
  /** Checks for equality with the object’s `activeHostingPlan` field. */
  activeHostingPlan?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdDate` field. */
  createdDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdUser` field. */
  createdUser?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `environmentName` field. */
  environmentName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `limitPods` field. */
  limitPods?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `tenantName` field. */
  tenantName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ServiceConfiguration` object types. All fields are combined with a logical ‘and.’ */
export type ServiceConfigurationFilter = {
  /** Filter by the object’s `activeHostingPlan` field. */
  activeHostingPlan?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ServiceConfigurationFilter>>;
  /** Filter by the object’s `createdDate` field. */
  createdDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdUser` field. */
  createdUser?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `environmentName` field. */
  environmentName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `hostingPlan` relation. */
  hostingPlan?: InputMaybe<HostingPlanFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `limitPods` field. */
  limitPods?: InputMaybe<IntFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ServiceConfigurationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ServiceConfigurationFilter>>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `tenantName` field. */
  tenantName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<StringFilter>;
};

/** A connection to a list of `ServiceConfiguration` values. */
export type ServiceConfigurationsConnection = {
  __typename?: 'ServiceConfigurationsConnection';
  /** A list of edges which contains the `ServiceConfiguration` and cursor to aid in pagination. */
  edges: Array<ServiceConfigurationsEdge>;
  /** A list of `ServiceConfiguration` objects. */
  nodes: Array<ServiceConfiguration>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ServiceConfiguration` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ServiceConfiguration` edge in the connection. */
export type ServiceConfigurationsEdge = {
  __typename?: 'ServiceConfigurationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ServiceConfiguration` at the end of the edge. */
  node: ServiceConfiguration;
};

/** Methods to use when ordering `ServiceConfiguration`. */
export enum ServiceConfigurationsOrderBy {
  ActiveHostingPlanAsc = 'ACTIVE_HOSTING_PLAN_ASC',
  ActiveHostingPlanDesc = 'ACTIVE_HOSTING_PLAN_DESC',
  CreatedDateAsc = 'CREATED_DATE_ASC',
  CreatedDateDesc = 'CREATED_DATE_DESC',
  CreatedUserAsc = 'CREATED_USER_ASC',
  CreatedUserDesc = 'CREATED_USER_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  EnvironmentNameAsc = 'ENVIRONMENT_NAME_ASC',
  EnvironmentNameDesc = 'ENVIRONMENT_NAME_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LimitPodsAsc = 'LIMIT_PODS_ASC',
  LimitPodsDesc = 'LIMIT_PODS_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  TenantNameAsc = 'TENANT_NAME_ASC',
  TenantNameDesc = 'TENANT_NAME_DESC',
  UpdatedDateAsc = 'UPDATED_DATE_ASC',
  UpdatedDateDesc = 'UPDATED_DATE_DESC',
  UpdatedUserAsc = 'UPDATED_USER_ASC',
  UpdatedUserDesc = 'UPDATED_USER_DESC'
}

export type ServiceDefinition = {
  __typename?: 'ServiceDefinition';
  activeDeploymentId?: Maybe<Scalars['UUID']['output']>;
  activeDeploymentStatus?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['Datetime']['output'];
  createdUser: Scalars['String']['output'];
  customDnsServiceLabel?: Maybe<Scalars['String']['output']>;
  databaseAccessExpiresAt?: Maybe<Scalars['Datetime']['output']>;
  /** Reads and enables pagination through a set of `DatabaseAccessSession`. */
  databaseAccessSessions: DatabaseAccessSessionsConnection;
  environmentId: Scalars['UUID']['output'];
  evaluationPodExpirationDate?: Maybe<Scalars['Datetime']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  overrideLimitCpu?: Maybe<Scalars['String']['output']>;
  overrideLimitRam?: Maybe<Scalars['String']['output']>;
  ownedByAxinom: Scalars['Boolean']['output'];
  refServiceDefinitionId?: Maybe<Scalars['UUID']['output']>;
  repositoryName: Scalars['String']['output'];
  repositoryTags: Array<ContainerImageDetails>;
  /** Reads and enables pagination through a set of `ServiceDeploymentManifest`. */
  serviceDeploymentManifest: ServiceDeploymentManifestsConnection;
  /** Reads and enables pagination through a set of `ServiceDeployment`. */
  serviceDeployments: ServiceDeploymentsConnection;
  serviceId: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `ServicePiletArtifact`. */
  servicePiletArtifacts: ServicePiletArtifactsConnection;
  tenantId: Scalars['UUID']['output'];
  updatedDate: Scalars['Datetime']['output'];
  updatedUser: Scalars['String']['output'];
};


export type ServiceDefinitionDatabaseAccessSessionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<DatabaseAccessSessionCondition>;
  filter?: InputMaybe<DatabaseAccessSessionFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DatabaseAccessSessionsOrderBy>>;
};


export type ServiceDefinitionServiceDeploymentManifestArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ServiceDeploymentManifestCondition>;
  filter?: InputMaybe<ServiceDeploymentManifestFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceDeploymentManifestsOrderBy>>;
};


export type ServiceDefinitionServiceDeploymentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ServiceDeploymentCondition>;
  filter?: InputMaybe<ServiceDeploymentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceDeploymentsOrderBy>>;
};


export type ServiceDefinitionServicePiletArtifactsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ServicePiletArtifactCondition>;
  filter?: InputMaybe<ServicePiletArtifactFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServicePiletArtifactsOrderBy>>;
};

/**
 * A condition to be used against `ServiceDefinition` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ServiceDefinitionCondition = {
  /** Checks for equality with the object’s `createdDate` field. */
  createdDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdUser` field. */
  createdUser?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `customDnsServiceLabel` field. */
  customDnsServiceLabel?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `databaseAccessExpiresAt` field. */
  databaseAccessExpiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `evaluationPodExpirationDate` field. */
  evaluationPodExpirationDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `overrideLimitCpu` field. */
  overrideLimitCpu?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `overrideLimitRam` field. */
  overrideLimitRam?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `ownedByAxinom` field. */
  ownedByAxinom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `refServiceDefinitionId` field. */
  refServiceDefinitionId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `repositoryName` field. */
  repositoryName?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `serviceId` field. */
  serviceId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ServiceDefinition` object types. All fields are combined with a logical ‘and.’ */
export type ServiceDefinitionFilter = {
  /** Filter by the object’s `activeDeploymentId` field. */
  activeDeploymentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `activeDeploymentStatus` field. */
  activeDeploymentStatus?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ServiceDefinitionFilter>>;
  /** Filter by the object’s `createdDate` field. */
  createdDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdUser` field. */
  createdUser?: InputMaybe<StringFilter>;
  /** Filter by the object’s `customDnsServiceLabel` field. */
  customDnsServiceLabel?: InputMaybe<StringFilter>;
  /** Filter by the object’s `databaseAccessExpiresAt` field. */
  databaseAccessExpiresAt?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `databaseAccessSessions` relation. */
  databaseAccessSessions?: InputMaybe<ServiceDefinitionToManyDatabaseAccessSessionFilter>;
  /** Some related `databaseAccessSessions` exist. */
  databaseAccessSessionsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `evaluationPodExpirationDate` field. */
  evaluationPodExpirationDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ServiceDefinitionFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ServiceDefinitionFilter>>;
  /** Filter by the object’s `overrideLimitCpu` field. */
  overrideLimitCpu?: InputMaybe<StringFilter>;
  /** Filter by the object’s `overrideLimitRam` field. */
  overrideLimitRam?: InputMaybe<StringFilter>;
  /** Filter by the object’s `ownedByAxinom` field. */
  ownedByAxinom?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `refServiceDefinitionId` field. */
  refServiceDefinitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `repositoryName` field. */
  repositoryName?: InputMaybe<StringFilter>;
  /** Filter by the object’s `serviceDeploymentManifest` relation. */
  serviceDeploymentManifest?: InputMaybe<ServiceDefinitionToManyServiceDeploymentManifestFilter>;
  /** Some related `serviceDeploymentManifest` exist. */
  serviceDeploymentManifestExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `serviceDeployments` relation. */
  serviceDeployments?: InputMaybe<ServiceDefinitionToManyServiceDeploymentFilter>;
  /** Some related `serviceDeployments` exist. */
  serviceDeploymentsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `serviceId` field. */
  serviceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `servicePiletArtifacts` relation. */
  servicePiletArtifacts?: InputMaybe<ServiceDefinitionToManyServicePiletArtifactFilter>;
  /** Some related `servicePiletArtifacts` exist. */
  servicePiletArtifactsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<StringFilter>;
};

/** An input for mutations affecting `ServiceDefinition` */
export type ServiceDefinitionInput = {
  customDnsServiceLabel?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  overrideLimitCpu?: InputMaybe<Scalars['String']['input']>;
  overrideLimitRam?: InputMaybe<Scalars['String']['input']>;
  repositoryName: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};

/** Represents an update to a `ServiceDefinition`. Fields that are set will be updated. */
export type ServiceDefinitionPatch = {
  customDnsServiceLabel?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overrideLimitCpu?: InputMaybe<Scalars['String']['input']>;
  overrideLimitRam?: InputMaybe<Scalars['String']['input']>;
  repositoryName?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against many `DatabaseAccessSession` object types. All fields are combined with a logical ‘and.’ */
export type ServiceDefinitionToManyDatabaseAccessSessionFilter = {
  /** Every related `DatabaseAccessSession` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<DatabaseAccessSessionFilter>;
  /** No related `DatabaseAccessSession` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<DatabaseAccessSessionFilter>;
  /** Some related `DatabaseAccessSession` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<DatabaseAccessSessionFilter>;
};

/** A filter to be used against many `ServiceDeployment` object types. All fields are combined with a logical ‘and.’ */
export type ServiceDefinitionToManyServiceDeploymentFilter = {
  /** Every related `ServiceDeployment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ServiceDeploymentFilter>;
  /** No related `ServiceDeployment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ServiceDeploymentFilter>;
  /** Some related `ServiceDeployment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ServiceDeploymentFilter>;
};

/** A filter to be used against many `ServiceDeploymentManifest` object types. All fields are combined with a logical ‘and.’ */
export type ServiceDefinitionToManyServiceDeploymentManifestFilter = {
  /** Every related `ServiceDeploymentManifest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ServiceDeploymentManifestFilter>;
  /** No related `ServiceDeploymentManifest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ServiceDeploymentManifestFilter>;
  /** Some related `ServiceDeploymentManifest` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ServiceDeploymentManifestFilter>;
};

/** A filter to be used against many `ServicePiletArtifact` object types. All fields are combined with a logical ‘and.’ */
export type ServiceDefinitionToManyServicePiletArtifactFilter = {
  /** Every related `ServicePiletArtifact` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ServicePiletArtifactFilter>;
  /** No related `ServicePiletArtifact` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ServicePiletArtifactFilter>;
  /** Some related `ServicePiletArtifact` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ServicePiletArtifactFilter>;
};

/** A connection to a list of `ServiceDefinition` values. */
export type ServiceDefinitionsConnection = {
  __typename?: 'ServiceDefinitionsConnection';
  /** A list of edges which contains the `ServiceDefinition` and cursor to aid in pagination. */
  edges: Array<ServiceDefinitionsEdge>;
  /** A list of `ServiceDefinition` objects. */
  nodes: Array<ServiceDefinition>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ServiceDefinition` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ServiceDefinition` edge in the connection. */
export type ServiceDefinitionsEdge = {
  __typename?: 'ServiceDefinitionsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ServiceDefinition` at the end of the edge. */
  node: ServiceDefinition;
};

/** Methods to use when ordering `ServiceDefinition`. */
export enum ServiceDefinitionsOrderBy {
  CreatedDateAsc = 'CREATED_DATE_ASC',
  CreatedDateDesc = 'CREATED_DATE_DESC',
  CreatedUserAsc = 'CREATED_USER_ASC',
  CreatedUserDesc = 'CREATED_USER_DESC',
  CustomDnsServiceLabelAsc = 'CUSTOM_DNS_SERVICE_LABEL_ASC',
  CustomDnsServiceLabelDesc = 'CUSTOM_DNS_SERVICE_LABEL_DESC',
  DatabaseAccessExpiresAtAsc = 'DATABASE_ACCESS_EXPIRES_AT_ASC',
  DatabaseAccessExpiresAtDesc = 'DATABASE_ACCESS_EXPIRES_AT_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  EvaluationPodExpirationDateAsc = 'EVALUATION_POD_EXPIRATION_DATE_ASC',
  EvaluationPodExpirationDateDesc = 'EVALUATION_POD_EXPIRATION_DATE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OverrideLimitCpuAsc = 'OVERRIDE_LIMIT_CPU_ASC',
  OverrideLimitCpuDesc = 'OVERRIDE_LIMIT_CPU_DESC',
  OverrideLimitRamAsc = 'OVERRIDE_LIMIT_RAM_ASC',
  OverrideLimitRamDesc = 'OVERRIDE_LIMIT_RAM_DESC',
  OwnedByAxinomAsc = 'OWNED_BY_AXINOM_ASC',
  OwnedByAxinomDesc = 'OWNED_BY_AXINOM_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RefServiceDefinitionIdAsc = 'REF_SERVICE_DEFINITION_ID_ASC',
  RefServiceDefinitionIdDesc = 'REF_SERVICE_DEFINITION_ID_DESC',
  RepositoryNameAsc = 'REPOSITORY_NAME_ASC',
  RepositoryNameDesc = 'REPOSITORY_NAME_DESC',
  ServiceIdAsc = 'SERVICE_ID_ASC',
  ServiceIdDesc = 'SERVICE_ID_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedDateAsc = 'UPDATED_DATE_ASC',
  UpdatedDateDesc = 'UPDATED_DATE_DESC',
  UpdatedUserAsc = 'UPDATED_USER_ASC',
  UpdatedUserDesc = 'UPDATED_USER_DESC'
}

export type ServiceDeployment = {
  __typename?: 'ServiceDeployment';
  active: Scalars['Boolean']['output'];
  containerImageVersion: Scalars['String']['output'];
  createdDate: Scalars['Datetime']['output'];
  createdUser: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `DnsRecord`. */
  dnsRecords: DnsRecordsConnection;
  environmentId: Scalars['UUID']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  replicaCount: Scalars['Int']['output'];
  serviceConfigurationId: Scalars['UUID']['output'];
  /** Reads a single `ServiceDefinition` that is related to this `ServiceDeployment`. */
  serviceDefinition?: Maybe<ServiceDefinition>;
  serviceDefinitionId: Scalars['UUID']['output'];
  /** Reads a single `ServiceDeploymentManifest` that is related to this `ServiceDeployment`. */
  serviceDeploymentManifest?: Maybe<ServiceDeploymentManifest>;
  serviceId?: Maybe<Scalars['String']['output']>;
  servicePiletArtifactIds: Array<Maybe<Scalars['UUID']['output']>>;
  servicePiletArtifacts?: Maybe<Scalars['String']['output']>;
  status: ResourceStatus;
  tenantId: Scalars['UUID']['output'];
  updatedDate: Scalars['Datetime']['output'];
  updatedUser: Scalars['String']['output'];
  vmSpecId: Scalars['String']['output'];
  /** Reads a single `VmSpecification` that is related to this `ServiceDeployment`. */
  vmSpecification?: Maybe<VmSpecification>;
};


export type ServiceDeploymentDnsRecordsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  filter?: InputMaybe<DnsRecordFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A condition to be used against `ServiceDeployment` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type ServiceDeploymentCondition = {
  /** Checks for equality with the object’s `active` field. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `containerImageVersion` field. */
  containerImageVersion?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `createdDate` field. */
  createdDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdUser` field. */
  createdUser?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `errorMessage` field. */
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `replicaCount` field. */
  replicaCount?: InputMaybe<Scalars['Int']['input']>;
  /** Checks for equality with the object’s `serviceConfigurationId` field. */
  serviceConfigurationId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `serviceDefinitionId` field. */
  serviceDefinitionId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `servicePiletArtifactIds` field. */
  servicePiletArtifactIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** Checks for equality with the object’s `status` field. */
  status?: InputMaybe<ResourceStatus>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `vmSpecId` field. */
  vmSpecId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ServiceDeployment` object types. All fields are combined with a logical ‘and.’ */
export type ServiceDeploymentFilter = {
  /** Filter by the object’s `active` field. */
  active?: InputMaybe<BooleanFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ServiceDeploymentFilter>>;
  /** Filter by the object’s `containerImageVersion` field. */
  containerImageVersion?: InputMaybe<StringFilter>;
  /** Filter by the object’s `createdDate` field. */
  createdDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdUser` field. */
  createdUser?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `errorMessage` field. */
  errorMessage?: InputMaybe<StringFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ServiceDeploymentFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ServiceDeploymentFilter>>;
  /** Filter by the object’s `replicaCount` field. */
  replicaCount?: InputMaybe<IntFilter>;
  /** Filter by the object’s `serviceConfigurationId` field. */
  serviceConfigurationId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `serviceDefinition` relation. */
  serviceDefinition?: InputMaybe<ServiceDefinitionFilter>;
  /** Filter by the object’s `serviceDefinitionId` field. */
  serviceDefinitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `serviceDeploymentManifest` relation. */
  serviceDeploymentManifest?: InputMaybe<ServiceDeploymentManifestFilter>;
  /** Filter by the object’s `serviceId` field. */
  serviceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `servicePiletArtifactIds` field. */
  servicePiletArtifactIds?: InputMaybe<UuidListFilter>;
  /** Filter by the object’s `servicePiletArtifacts` field. */
  servicePiletArtifacts?: InputMaybe<StringFilter>;
  /** Filter by the object’s `status` field. */
  status?: InputMaybe<ResourceStatusFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<StringFilter>;
  /** Filter by the object’s `vmSpecId` field. */
  vmSpecId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `vmSpecification` relation. */
  vmSpecification?: InputMaybe<VmSpecificationFilter>;
};

export type ServiceDeploymentLog = {
  __typename?: 'ServiceDeploymentLog';
  environmentId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  initiatedBy: Scalars['String']['output'];
  isActiveDeployment: Scalars['Boolean']['output'];
  message?: Maybe<Scalars['JSON']['output']>;
  messageType: Scalars['String']['output'];
  serviceDefinitionId: Scalars['UUID']['output'];
  serviceDeploymentId: Scalars['UUID']['output'];
  serviceId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['UUID']['output'];
  timestamp: Scalars['Datetime']['output'];
};

/**
 * A condition to be used against `ServiceDeploymentLog` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ServiceDeploymentLogCondition = {
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `initiatedBy` field. */
  initiatedBy?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `isActiveDeployment` field. */
  isActiveDeployment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `message` field. */
  message?: InputMaybe<Scalars['JSON']['input']>;
  /** Checks for equality with the object’s `messageType` field. */
  messageType?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `serviceDefinitionId` field. */
  serviceDefinitionId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `serviceDeploymentId` field. */
  serviceDeploymentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `timestamp` field. */
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
};

/** A filter to be used against `ServiceDeploymentLog` object types. All fields are combined with a logical ‘and.’ */
export type ServiceDeploymentLogFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ServiceDeploymentLogFilter>>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `initiatedBy` field. */
  initiatedBy?: InputMaybe<StringFilter>;
  /** Filter by the object’s `isActiveDeployment` field. */
  isActiveDeployment?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `message` field. */
  message?: InputMaybe<JsonFilter>;
  /** Filter by the object’s `messageType` field. */
  messageType?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ServiceDeploymentLogFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ServiceDeploymentLogFilter>>;
  /** Filter by the object’s `serviceDefinitionId` field. */
  serviceDefinitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `serviceDeploymentId` field. */
  serviceDeploymentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `serviceId` field. */
  serviceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `timestamp` field. */
  timestamp?: InputMaybe<DatetimeFilter>;
};

/** A connection to a list of `ServiceDeploymentLog` values. */
export type ServiceDeploymentLogsConnection = {
  __typename?: 'ServiceDeploymentLogsConnection';
  /** A list of edges which contains the `ServiceDeploymentLog` and cursor to aid in pagination. */
  edges: Array<ServiceDeploymentLogsEdge>;
  /** A list of `ServiceDeploymentLog` objects. */
  nodes: Array<ServiceDeploymentLog>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ServiceDeploymentLog` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ServiceDeploymentLog` edge in the connection. */
export type ServiceDeploymentLogsEdge = {
  __typename?: 'ServiceDeploymentLogsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ServiceDeploymentLog` at the end of the edge. */
  node: ServiceDeploymentLog;
};

/** Methods to use when ordering `ServiceDeploymentLog`. */
export enum ServiceDeploymentLogsOrderBy {
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  InitiatedByAsc = 'INITIATED_BY_ASC',
  InitiatedByDesc = 'INITIATED_BY_DESC',
  MessageAsc = 'MESSAGE_ASC',
  MessageDesc = 'MESSAGE_DESC',
  MessageTypeAsc = 'MESSAGE_TYPE_ASC',
  MessageTypeDesc = 'MESSAGE_TYPE_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ServiceDeploymentIdAsc = 'SERVICE_DEPLOYMENT_ID_ASC',
  ServiceDeploymentIdDesc = 'SERVICE_DEPLOYMENT_ID_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  TimestampAsc = 'TIMESTAMP_ASC',
  TimestampDesc = 'TIMESTAMP_DESC'
}

export type ServiceDeploymentManifest = {
  __typename?: 'ServiceDeploymentManifest';
  activeDeploymentId?: Maybe<Scalars['UUID']['output']>;
  activeDeploymentStatus?: Maybe<Scalars['String']['output']>;
  configMap: Scalars['DeploymentConfigMap']['output'];
  createdDate: Scalars['Datetime']['output'];
  createdUser: Scalars['String']['output'];
  currentlyInUse?: Maybe<Scalars['Boolean']['output']>;
  environmentId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  ownedByAxinom: Scalars['Boolean']['output'];
  refServiceDeploymentConfigId?: Maybe<Scalars['UUID']['output']>;
  /** Reads a single `ServiceDefinition` that is related to this `ServiceDeploymentManifest`. */
  serviceDefinition?: Maybe<ServiceDefinition>;
  serviceDefinitionId: Scalars['UUID']['output'];
  /** Reads and enables pagination through a set of `ServiceDeployment`. */
  serviceDeployments: ServiceDeploymentsConnection;
  serviceId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['UUID']['output'];
  updatedDate: Scalars['Datetime']['output'];
  updatedUser: Scalars['String']['output'];
};


export type ServiceDeploymentManifestServiceDeploymentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ServiceDeploymentCondition>;
  filter?: InputMaybe<ServiceDeploymentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceDeploymentsOrderBy>>;
};

/**
 * A condition to be used against `ServiceDeploymentManifest` object types. All
 * fields are tested for equality and combined with a logical ‘and.’
 */
export type ServiceDeploymentManifestCondition = {
  /** Checks for equality with the object’s `configMap` field. */
  configMap?: InputMaybe<Scalars['DeploymentConfigMap']['input']>;
  /** Checks for equality with the object’s `createdDate` field. */
  createdDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdUser` field. */
  createdUser?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `ownedByAxinom` field. */
  ownedByAxinom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `refServiceDeploymentConfigId` field. */
  refServiceDeploymentConfigId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `serviceDefinitionId` field. */
  serviceDefinitionId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ServiceDeploymentManifest` object types. All fields are combined with a logical ‘and.’ */
export type ServiceDeploymentManifestFilter = {
  /** Filter by the object’s `activeDeploymentId` field. */
  activeDeploymentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `activeDeploymentStatus` field. */
  activeDeploymentStatus?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ServiceDeploymentManifestFilter>>;
  /** Filter by the object’s `configMap` field. */
  configMap?: InputMaybe<DeploymentConfigMapFilter>;
  /** Filter by the object’s `createdDate` field. */
  createdDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdUser` field. */
  createdUser?: InputMaybe<StringFilter>;
  /** Filter by the object’s `currentlyInUse` field. */
  currentlyInUse?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ServiceDeploymentManifestFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ServiceDeploymentManifestFilter>>;
  /** Filter by the object’s `ownedByAxinom` field. */
  ownedByAxinom?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `refServiceDeploymentConfigId` field. */
  refServiceDeploymentConfigId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `serviceDefinition` relation. */
  serviceDefinition?: InputMaybe<ServiceDefinitionFilter>;
  /** Filter by the object’s `serviceDefinitionId` field. */
  serviceDefinitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `serviceDeployments` relation. */
  serviceDeployments?: InputMaybe<ServiceDeploymentManifestToManyServiceDeploymentFilter>;
  /** Some related `serviceDeployments` exist. */
  serviceDeploymentsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `serviceId` field. */
  serviceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<StringFilter>;
};

/** Represents an update to a `ServiceDeploymentManifest`. Fields that are set will be updated. */
export type ServiceDeploymentManifestPatch = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against many `ServiceDeployment` object types. All fields are combined with a logical ‘and.’ */
export type ServiceDeploymentManifestToManyServiceDeploymentFilter = {
  /** Every related `ServiceDeployment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ServiceDeploymentFilter>;
  /** No related `ServiceDeployment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ServiceDeploymentFilter>;
  /** Some related `ServiceDeployment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ServiceDeploymentFilter>;
};

/** A connection to a list of `ServiceDeploymentManifest` values. */
export type ServiceDeploymentManifestsConnection = {
  __typename?: 'ServiceDeploymentManifestsConnection';
  /** A list of edges which contains the `ServiceDeploymentManifest` and cursor to aid in pagination. */
  edges: Array<ServiceDeploymentManifestsEdge>;
  /** A list of `ServiceDeploymentManifest` objects. */
  nodes: Array<ServiceDeploymentManifest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ServiceDeploymentManifest` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ServiceDeploymentManifest` edge in the connection. */
export type ServiceDeploymentManifestsEdge = {
  __typename?: 'ServiceDeploymentManifestsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ServiceDeploymentManifest` at the end of the edge. */
  node: ServiceDeploymentManifest;
};

/** Methods to use when ordering `ServiceDeploymentManifest`. */
export enum ServiceDeploymentManifestsOrderBy {
  ConfigMapAsc = 'CONFIG_MAP_ASC',
  ConfigMapDesc = 'CONFIG_MAP_DESC',
  CreatedDateAsc = 'CREATED_DATE_ASC',
  CreatedDateDesc = 'CREATED_DATE_DESC',
  CreatedUserAsc = 'CREATED_USER_ASC',
  CreatedUserDesc = 'CREATED_USER_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OwnedByAxinomAsc = 'OWNED_BY_AXINOM_ASC',
  OwnedByAxinomDesc = 'OWNED_BY_AXINOM_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RefServiceDeploymentConfigIdAsc = 'REF_SERVICE_DEPLOYMENT_CONFIG_ID_ASC',
  RefServiceDeploymentConfigIdDesc = 'REF_SERVICE_DEPLOYMENT_CONFIG_ID_DESC',
  ServiceDefinitionIdAsc = 'SERVICE_DEFINITION_ID_ASC',
  ServiceDefinitionIdDesc = 'SERVICE_DEFINITION_ID_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedDateAsc = 'UPDATED_DATE_ASC',
  UpdatedDateDesc = 'UPDATED_DATE_DESC',
  UpdatedUserAsc = 'UPDATED_USER_ASC',
  UpdatedUserDesc = 'UPDATED_USER_DESC'
}

/** Represents an update to a `ServiceDeployment`. Fields that are set will be updated. */
export type ServiceDeploymentPatch = {
  name?: InputMaybe<Scalars['String']['input']>;
};

/** A connection to a list of `ServiceDeployment` values. */
export type ServiceDeploymentsConnection = {
  __typename?: 'ServiceDeploymentsConnection';
  /** A list of edges which contains the `ServiceDeployment` and cursor to aid in pagination. */
  edges: Array<ServiceDeploymentsEdge>;
  /** A list of `ServiceDeployment` objects. */
  nodes: Array<ServiceDeployment>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ServiceDeployment` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ServiceDeployment` edge in the connection. */
export type ServiceDeploymentsEdge = {
  __typename?: 'ServiceDeploymentsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ServiceDeployment` at the end of the edge. */
  node: ServiceDeployment;
};

/** Methods to use when ordering `ServiceDeployment`. */
export enum ServiceDeploymentsOrderBy {
  ActiveAsc = 'ACTIVE_ASC',
  ActiveDesc = 'ACTIVE_DESC',
  ContainerImageVersionAsc = 'CONTAINER_IMAGE_VERSION_ASC',
  ContainerImageVersionDesc = 'CONTAINER_IMAGE_VERSION_DESC',
  CreatedDateAsc = 'CREATED_DATE_ASC',
  CreatedDateDesc = 'CREATED_DATE_DESC',
  CreatedUserAsc = 'CREATED_USER_ASC',
  CreatedUserDesc = 'CREATED_USER_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  ErrorMessageAsc = 'ERROR_MESSAGE_ASC',
  ErrorMessageDesc = 'ERROR_MESSAGE_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  ReplicaCountAsc = 'REPLICA_COUNT_ASC',
  ReplicaCountDesc = 'REPLICA_COUNT_DESC',
  ServiceConfigurationIdAsc = 'SERVICE_CONFIGURATION_ID_ASC',
  ServiceConfigurationIdDesc = 'SERVICE_CONFIGURATION_ID_DESC',
  ServiceDefinitionIdAsc = 'SERVICE_DEFINITION_ID_ASC',
  ServiceDefinitionIdDesc = 'SERVICE_DEFINITION_ID_DESC',
  ServicePiletArtifactIdsAsc = 'SERVICE_PILET_ARTIFACT_IDS_ASC',
  ServicePiletArtifactIdsDesc = 'SERVICE_PILET_ARTIFACT_IDS_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedDateAsc = 'UPDATED_DATE_ASC',
  UpdatedDateDesc = 'UPDATED_DATE_DESC',
  UpdatedUserAsc = 'UPDATED_USER_ASC',
  UpdatedUserDesc = 'UPDATED_USER_DESC',
  VmSpecIdAsc = 'VM_SPEC_ID_ASC',
  VmSpecIdDesc = 'VM_SPEC_ID_DESC'
}

export type ServicePiletArtifact = {
  __typename?: 'ServicePiletArtifact';
  activeDeploymentId?: Maybe<Scalars['UUID']['output']>;
  activeDeploymentStatus?: Maybe<Scalars['String']['output']>;
  createdDate: Scalars['Datetime']['output'];
  createdUser: Scalars['String']['output'];
  environmentId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  ownedByAxinom: Scalars['Boolean']['output'];
  packageVersion: Scalars['String']['output'];
  refServicePiletArtifactId?: Maybe<Scalars['UUID']['output']>;
  /** Reads a single `ServiceDefinition` that is related to this `ServicePiletArtifact`. */
  serviceDefinition?: Maybe<ServiceDefinition>;
  serviceDefinitionId: Scalars['UUID']['output'];
  serviceId?: Maybe<Scalars['String']['output']>;
  tenantId: Scalars['UUID']['output'];
  updatedDate: Scalars['Datetime']['output'];
  updatedUser: Scalars['String']['output'];
};

/**
 * A condition to be used against `ServicePiletArtifact` object types. All fields
 * are tested for equality and combined with a logical ‘and.’
 */
export type ServicePiletArtifactCondition = {
  /** Checks for equality with the object’s `createdDate` field. */
  createdDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdUser` field. */
  createdUser?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `environmentId` field. */
  environmentId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `id` field. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `name` field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `ownedByAxinom` field. */
  ownedByAxinom?: InputMaybe<Scalars['Boolean']['input']>;
  /** Checks for equality with the object’s `packageVersion` field. */
  packageVersion?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `refServicePiletArtifactId` field. */
  refServicePiletArtifactId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `serviceDefinitionId` field. */
  serviceDefinitionId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `tenantId` field. */
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  /** Checks for equality with the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `ServicePiletArtifact` object types. All fields are combined with a logical ‘and.’ */
export type ServicePiletArtifactFilter = {
  /** Filter by the object’s `activeDeploymentId` field. */
  activeDeploymentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `activeDeploymentStatus` field. */
  activeDeploymentStatus?: InputMaybe<StringFilter>;
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<ServicePiletArtifactFilter>>;
  /** Filter by the object’s `createdDate` field. */
  createdDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdUser` field. */
  createdUser?: InputMaybe<StringFilter>;
  /** Filter by the object’s `environmentId` field. */
  environmentId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `id` field. */
  id?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `name` field. */
  name?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<ServicePiletArtifactFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<ServicePiletArtifactFilter>>;
  /** Filter by the object’s `ownedByAxinom` field. */
  ownedByAxinom?: InputMaybe<BooleanFilter>;
  /** Filter by the object’s `packageVersion` field. */
  packageVersion?: InputMaybe<StringFilter>;
  /** Filter by the object’s `refServicePiletArtifactId` field. */
  refServicePiletArtifactId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `serviceDefinition` relation. */
  serviceDefinition?: InputMaybe<ServiceDefinitionFilter>;
  /** Filter by the object’s `serviceDefinitionId` field. */
  serviceDefinitionId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `serviceId` field. */
  serviceId?: InputMaybe<StringFilter>;
  /** Filter by the object’s `tenantId` field. */
  tenantId?: InputMaybe<UuidFilter>;
  /** Filter by the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<StringFilter>;
};

/** A connection to a list of `ServicePiletArtifact` values. */
export type ServicePiletArtifactsConnection = {
  __typename?: 'ServicePiletArtifactsConnection';
  /** A list of edges which contains the `ServicePiletArtifact` and cursor to aid in pagination. */
  edges: Array<ServicePiletArtifactsEdge>;
  /** A list of `ServicePiletArtifact` objects. */
  nodes: Array<ServicePiletArtifact>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `ServicePiletArtifact` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `ServicePiletArtifact` edge in the connection. */
export type ServicePiletArtifactsEdge = {
  __typename?: 'ServicePiletArtifactsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `ServicePiletArtifact` at the end of the edge. */
  node: ServicePiletArtifact;
};

/** Methods to use when ordering `ServicePiletArtifact`. */
export enum ServicePiletArtifactsOrderBy {
  CreatedDateAsc = 'CREATED_DATE_ASC',
  CreatedDateDesc = 'CREATED_DATE_DESC',
  CreatedUserAsc = 'CREATED_USER_ASC',
  CreatedUserDesc = 'CREATED_USER_DESC',
  EnvironmentIdAsc = 'ENVIRONMENT_ID_ASC',
  EnvironmentIdDesc = 'ENVIRONMENT_ID_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  Natural = 'NATURAL',
  OwnedByAxinomAsc = 'OWNED_BY_AXINOM_ASC',
  OwnedByAxinomDesc = 'OWNED_BY_AXINOM_DESC',
  PackageVersionAsc = 'PACKAGE_VERSION_ASC',
  PackageVersionDesc = 'PACKAGE_VERSION_DESC',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  RefServicePiletArtifactIdAsc = 'REF_SERVICE_PILET_ARTIFACT_ID_ASC',
  RefServicePiletArtifactIdDesc = 'REF_SERVICE_PILET_ARTIFACT_ID_DESC',
  ServiceDefinitionIdAsc = 'SERVICE_DEFINITION_ID_ASC',
  ServiceDefinitionIdDesc = 'SERVICE_DEFINITION_ID_DESC',
  TenantIdAsc = 'TENANT_ID_ASC',
  TenantIdDesc = 'TENANT_ID_DESC',
  UpdatedDateAsc = 'UPDATED_DATE_ASC',
  UpdatedDateDesc = 'UPDATED_DATE_DESC',
  UpdatedUserAsc = 'UPDATED_USER_ASC',
  UpdatedUserDesc = 'UPDATED_USER_DESC'
}

/** Log lines from a single running replica of a deployed service. */
export type ServiceReplicaLog = {
  __typename?: 'ServiceReplicaLog';
  /**
   * One entry per line, each prefixed with the RFC3339 timestamp Kubernetes
   * recorded for it, followed by a space and then the line exactly as the
   * service emitted it. The service's own output is never parsed or
   * normalised -- it is free to log plain text rather than structured JSON --
   * so the prefix is the only reliable key for ordering lines across
   * replicas.
   */
  lines: Array<Scalars['String']['output']>;
  /**
   * Name of the replica the lines were read from. Useful to correlate lines
   * when a service runs with a replica count greater than one.
   */
  replicaName: Scalars['String']['output'];
};

/** The input type to retrieve runtime logs of a deployed service. */
export type ServiceRuntimeLogsInput = {
  /** The service ID to read logs for. Unique within a tenant/environment. */
  serviceId: Scalars['String']['input'];
  /** Only return log lines newer than this many seconds. */
  sinceSeconds?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Maximum number of log lines returned per replica, counted from the end
   * of the log. A server-side default and cap apply when omitted or exceeded.
   */
  tailLines?: InputMaybe<Scalars['Int']['input']>;
};

/** Runtime logs grouped by the replica that produced them. */
export type ServiceRuntimeLogsResult = {
  __typename?: 'ServiceRuntimeLogsResult';
  replicas: Array<ServiceReplicaLog>;
};

/**
 * Input Type for the setDatabaseAccess mutation.
 * Expects:
 * - serviceDefinitionId
 * - enabled
 */
export type SetDatabaseAccessInput = {
  enabled: Scalars['Boolean']['input'];
  serviceDefinitionId: Scalars['UUID']['input'];
};

/** Response for the setDatabaseAccess mutation. */
export type SetDatabaseAccessPayload = {
  __typename?: 'SetDatabaseAccessPayload';
  databaseAccessExpiresAt?: Maybe<Scalars['Datetime']['output']>;
  serviceDefinitionId: Scalars['UUID']['output'];
};

/**
 * Input Type for the setServiceExpirationDate mutation.
 * Expects:
 * - serviceDefinitionId
 * - expirationDate
 */
export type SetServiceExpirationDateInput = {
  expirationDate: Scalars['Datetime']['input'];
  serviceDefinitionId: Scalars['UUID']['input'];
};

/** Response for setServiceExpirationDate mutation. */
export type SetServiceExpirationDatePayload = {
  __typename?: 'SetServiceExpirationDatePayload';
  expirationDate: Scalars['Datetime']['output'];
  serviceDefinitionId: Scalars['UUID']['output'];
};

export type SetupRmqUserPayload = {
  __typename?: 'SetupRMQUserPayload';
  environmentId: Scalars['String']['output'];
  rmqHost: Scalars['String']['output'];
  rmqMgmtHost: Scalars['String']['output'];
  rmqMgmtPort: Scalars['String']['output'];
  rmqMgmtProtocol: Scalars['String']['output'];
  rmqPassword: Scalars['String']['output'];
  rmqPort: Scalars['String']['output'];
  rmqProtocol: Scalars['String']['output'];
  rmqUser: Scalars['String']['output'];
  rmqVHost: Scalars['String']['output'];
  tenantId: Scalars['String']['output'];
};

/**
 * The input type to store a vault secret.
 * The respective serviceId must be provided with the list
 * of secrets to be stored.
 */
export type StoreVaultSecretsInput = {
  secrets: Array<VaultSecretToStore>;
  serviceId: Scalars['String']['input'];
};

/** The return type containing an array of stored secret names along with versions. */
export type StoreVaultSecretsPayload = {
  __typename?: 'StoreVaultSecretsPayload';
  storedSecrets?: Maybe<Array<StoredVaultSecret>>;
};

/**
 * This GraphQL type is used when returning a stored secrets
 * along with version.
 */
export type StoredVaultSecret = {
  __typename?: 'StoredVaultSecret';
  name: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** A filter to be used against String fields. All fields are combined with a logical ‘and.’ */
export type StringFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value, treating null like an ordinary value (case-insensitive). */
  distinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-sensitive). */
  endsWith?: InputMaybe<Scalars['String']['input']>;
  /** Ends with the specified string (case-insensitive). */
  endsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value (case-insensitive). */
  equalToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Greater than the specified value (case-insensitive). */
  greaterThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Greater than or equal to the specified value (case-insensitive). */
  greaterThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Included in the specified list (case-insensitive). */
  inInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Contains the specified string (case-sensitive). */
  includes?: InputMaybe<Scalars['String']['input']>;
  /** Contains the specified string (case-insensitive). */
  includesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['String']['input']>;
  /** Less than the specified value (case-insensitive). */
  lessThanInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Less than or equal to the specified value (case-insensitive). */
  lessThanOrEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  like?: InputMaybe<Scalars['String']['input']>;
  /** Matches the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  likeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['String']['input']>;
  /** Equal to the specified value, treating null like an ordinary value (case-insensitive). */
  notDistinctFromInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-sensitive). */
  notEndsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not end with the specified string (case-insensitive). */
  notEndsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['String']['input']>;
  /** Not equal to the specified value (case-insensitive). */
  notEqualToInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Not included in the specified list (case-insensitive). */
  notInInsensitive?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Does not contain the specified string (case-sensitive). */
  notIncludes?: InputMaybe<Scalars['String']['input']>;
  /** Does not contain the specified string (case-insensitive). */
  notIncludesInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-sensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLike?: InputMaybe<Scalars['String']['input']>;
  /** Does not match the specified pattern (case-insensitive). An underscore (_) matches any single character; a percent sign (%) matches any sequence of zero or more characters. */
  notLikeInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-sensitive). */
  notStartsWith?: InputMaybe<Scalars['String']['input']>;
  /** Does not start with the specified string (case-insensitive). */
  notStartsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-sensitive). */
  startsWith?: InputMaybe<Scalars['String']['input']>;
  /** Starts with the specified string (case-insensitive). */
  startsWithInsensitive?: InputMaybe<Scalars['String']['input']>;
};

/** The root subscription type: contains realtime events you can subscribe to with the `subscription` operation. */
export type Subscription = {
  __typename?: 'Subscription';
  /** Triggered when a ObjectStorageLog is mutated (insert, update or delete).  */
  objectStorageLogMutated?: Maybe<ObjectStorageLogSubscriptionPayload>;
  /** Triggered when a ObjectStorage is mutated (insert, update or delete).  */
  objectStorageMutated?: Maybe<ObjectStorageSubscriptionPayload>;
};

/** A filter to be used against UUID fields. All fields are combined with a logical ‘and.’ */
export type UuidFilter = {
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Included in the specified list. */
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Scalars['UUID']['input']>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Not included in the specified list. */
  notIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** A filter to be used against UUID List fields. All fields are combined with a logical ‘and.’ */
export type UuidListFilter = {
  /** Any array item is equal to the specified value. */
  anyEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Any array item is greater than the specified value. */
  anyGreaterThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Any array item is greater than or equal to the specified value. */
  anyGreaterThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Any array item is less than the specified value. */
  anyLessThan?: InputMaybe<Scalars['UUID']['input']>;
  /** Any array item is less than or equal to the specified value. */
  anyLessThanOrEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Any array item is not equal to the specified value. */
  anyNotEqualTo?: InputMaybe<Scalars['UUID']['input']>;
  /** Contained by the specified list of values. */
  containedBy?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** Contains the specified list of values. */
  contains?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** Not equal to the specified value, treating null like an ordinary value. */
  distinctFrom?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** Equal to the specified value. */
  equalTo?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** Greater than the specified value. */
  greaterThan?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** Greater than or equal to the specified value. */
  greaterThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** Is null (if `true` is specified) or is not null (if `false` is specified). */
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** Less than the specified value. */
  lessThan?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** Less than or equal to the specified value. */
  lessThanOrEqualTo?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** Equal to the specified value, treating null like an ordinary value. */
  notDistinctFrom?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** Not equal to the specified value. */
  notEqualTo?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
  /** Overlaps the specified list of values. */
  overlaps?: InputMaybe<Array<InputMaybe<Scalars['UUID']['input']>>>;
};

export type UpdateAzureStorageContainerInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  patch: AzureStorageContainerPatch;
  provider: Scalars['String']['input'];
  storageAccountName: Scalars['String']['input'];
};

export type UpdateAzureStorageContainerMutationPayload = {
  __typename?: 'UpdateAzureStorageContainerMutationPayload';
  container?: Maybe<UpdatedAzureStorageContainer>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** All input for the `updateContainerRegistryConnection` mutation. */
export type UpdateContainerRegistryConnectionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `ContainerRegistryConnection` being updated. */
  patch: ContainerRegistryConnectionPatch;
};

/** The output of our update `ContainerRegistryConnection` mutation. */
export type UpdateContainerRegistryConnectionPayload = {
  __typename?: 'UpdateContainerRegistryConnectionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The `ContainerRegistryConnection` that was updated by this mutation. */
  containerRegistryConnection?: Maybe<ContainerRegistryConnection>;
  /** An edge for our `ContainerRegistryConnection`. May be used by Relay 1. */
  containerRegistryConnectionEdge?: Maybe<ContainerRegistryConnectionsEdge>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
};


/** The output of our update `ContainerRegistryConnection` mutation. */
export type UpdateContainerRegistryConnectionPayloadContainerRegistryConnectionEdgeArgs = {
  orderBy?: InputMaybe<Array<ContainerRegistryConnectionsOrderBy>>;
};

/** All input for the `updateServiceDefinition` mutation. */
export type UpdateServiceDefinitionInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `ServiceDefinition` being updated. */
  patch: ServiceDefinitionPatch;
};

/** The output of our update `ServiceDefinition` mutation. */
export type UpdateServiceDefinitionPayload = {
  __typename?: 'UpdateServiceDefinitionPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** The `ServiceDefinition` that was updated by this mutation. */
  serviceDefinition?: Maybe<ServiceDefinition>;
  /** An edge for our `ServiceDefinition`. May be used by Relay 1. */
  serviceDefinitionEdge?: Maybe<ServiceDefinitionsEdge>;
};


/** The output of our update `ServiceDefinition` mutation. */
export type UpdateServiceDefinitionPayloadServiceDefinitionEdgeArgs = {
  orderBy?: InputMaybe<Array<ServiceDefinitionsOrderBy>>;
};

/** All input for the `updateServiceDeployment` mutation. */
export type UpdateServiceDeploymentInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `ServiceDeployment` being updated. */
  patch: ServiceDeploymentPatch;
};

/** All input for the `updateServiceDeploymentManifest` mutation. */
export type UpdateServiceDeploymentManifestInput = {
  /**
   * An arbitrary string value with no semantic meaning. Will be included in the
   * payload verbatim. May be used to track mutations by the client.
   */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  /** An object where the defined keys will be set on the `ServiceDeploymentManifest` being updated. */
  patch: ServiceDeploymentManifestPatch;
};

/** The output of our update `ServiceDeploymentManifest` mutation. */
export type UpdateServiceDeploymentManifestPayload = {
  __typename?: 'UpdateServiceDeploymentManifestPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ServiceDefinition` that is related to this `ServiceDeploymentManifest`. */
  serviceDefinition?: Maybe<ServiceDefinition>;
  /** The `ServiceDeploymentManifest` that was updated by this mutation. */
  serviceDeploymentManifest?: Maybe<ServiceDeploymentManifest>;
  /** An edge for our `ServiceDeploymentManifest`. May be used by Relay 1. */
  serviceDeploymentManifestEdge?: Maybe<ServiceDeploymentManifestsEdge>;
};


/** The output of our update `ServiceDeploymentManifest` mutation. */
export type UpdateServiceDeploymentManifestPayloadServiceDeploymentManifestEdgeArgs = {
  orderBy?: InputMaybe<Array<ServiceDeploymentManifestsOrderBy>>;
};

/** The output of our update `ServiceDeployment` mutation. */
export type UpdateServiceDeploymentPayload = {
  __typename?: 'UpdateServiceDeploymentPayload';
  /**
   * The exact same `clientMutationId` that was provided in the mutation input,
   * unchanged and unused. May be used by a client to track mutations.
   */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Our root query field type. Allows us to run any query from our mutation payload. */
  query?: Maybe<Query>;
  /** Reads a single `ServiceDefinition` that is related to this `ServiceDeployment`. */
  serviceDefinition?: Maybe<ServiceDefinition>;
  /** The `ServiceDeployment` that was updated by this mutation. */
  serviceDeployment?: Maybe<ServiceDeployment>;
  /** An edge for our `ServiceDeployment`. May be used by Relay 1. */
  serviceDeploymentEdge?: Maybe<ServiceDeploymentsEdge>;
  /** Reads a single `ServiceDeploymentManifest` that is related to this `ServiceDeployment`. */
  serviceDeploymentManifest?: Maybe<ServiceDeploymentManifest>;
  /** Reads a single `VmSpecification` that is related to this `ServiceDeployment`. */
  vmSpecification?: Maybe<VmSpecification>;
};


/** The output of our update `ServiceDeployment` mutation. */
export type UpdateServiceDeploymentPayloadServiceDeploymentEdgeArgs = {
  orderBy?: InputMaybe<Array<ServiceDeploymentsOrderBy>>;
};

export type UpdatedAzureStorageContainer = {
  __typename?: 'UpdatedAzureStorageContainer';
  hasPublicReadAccess?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  publicUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
};

/**
 * The input type to store a Secret in a secure vault.
 * The name can only contain alphanumeric values and hyphens, and
 * must be between 1 and 127 characters.
 */
export type VaultSecretToStore = {
  name: Scalars['String']['input'];
  secret: Scalars['String']['input'];
};

/** The input type to retrieve a set of stored secrets from a vault. */
export type VaultSecretsInput = {
  secretsToRetrieve: Array<VaultSecretsToRetrieve>;
  serviceId: Scalars['String']['input'];
};

/** The return type containing an array of secrets names along with the value. */
export type VaultSecretsPayload = {
  __typename?: 'VaultSecretsPayload';
  secrets?: Maybe<Array<RetrievedVaultSecret>>;
};

/**
 * This input type is used to retrieve stored secrets from vault.
 * The version is optional and if not provided, the secret value for the latest
 * version will be returned.
 */
export type VaultSecretsToRetrieve = {
  name: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};

export type VmSpecification = {
  __typename?: 'VmSpecification';
  createdDate: Scalars['Datetime']['output'];
  createdUser: Scalars['String']['output'];
  defaultLimitCpu: Scalars['String']['output'];
  defaultLimitRam: Scalars['String']['output'];
  /** Reads a single `HostingPlan` that is related to this `VmSpecification`. */
  hostingPlan?: Maybe<HostingPlan>;
  hostingPlanId: Scalars['String']['output'];
  /** Reads and enables pagination through a set of `ServiceDeployment`. */
  serviceDeployments: ServiceDeploymentsConnection;
  title: Scalars['String']['output'];
  updatedDate: Scalars['Datetime']['output'];
  updatedUser: Scalars['String']['output'];
  vmSpecId: Scalars['String']['output'];
};


export type VmSpecificationServiceDeploymentsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  before?: InputMaybe<Scalars['Cursor']['input']>;
  condition?: InputMaybe<ServiceDeploymentCondition>;
  filter?: InputMaybe<ServiceDeploymentFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ServiceDeploymentsOrderBy>>;
};

/**
 * A condition to be used against `VmSpecification` object types. All fields are
 * tested for equality and combined with a logical ‘and.’
 */
export type VmSpecificationCondition = {
  /** Checks for equality with the object’s `createdDate` field. */
  createdDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `createdUser` field. */
  createdUser?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `defaultLimitCpu` field. */
  defaultLimitCpu?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `defaultLimitRam` field. */
  defaultLimitRam?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `hostingPlanId` field. */
  hostingPlanId?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `title` field. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<Scalars['Datetime']['input']>;
  /** Checks for equality with the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<Scalars['String']['input']>;
  /** Checks for equality with the object’s `vmSpecId` field. */
  vmSpecId?: InputMaybe<Scalars['String']['input']>;
};

/** A filter to be used against `VmSpecification` object types. All fields are combined with a logical ‘and.’ */
export type VmSpecificationFilter = {
  /** Checks for all expressions in this list. */
  and?: InputMaybe<Array<VmSpecificationFilter>>;
  /** Filter by the object’s `createdDate` field. */
  createdDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `createdUser` field. */
  createdUser?: InputMaybe<StringFilter>;
  /** Filter by the object’s `defaultLimitCpu` field. */
  defaultLimitCpu?: InputMaybe<StringFilter>;
  /** Filter by the object’s `defaultLimitRam` field. */
  defaultLimitRam?: InputMaybe<StringFilter>;
  /** Filter by the object’s `hostingPlan` relation. */
  hostingPlan?: InputMaybe<HostingPlanFilter>;
  /** Filter by the object’s `hostingPlanId` field. */
  hostingPlanId?: InputMaybe<StringFilter>;
  /** Negates the expression. */
  not?: InputMaybe<VmSpecificationFilter>;
  /** Checks for any expressions in this list. */
  or?: InputMaybe<Array<VmSpecificationFilter>>;
  /** Filter by the object’s `serviceDeployments` relation. */
  serviceDeployments?: InputMaybe<VmSpecificationToManyServiceDeploymentFilter>;
  /** Some related `serviceDeployments` exist. */
  serviceDeploymentsExist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the object’s `title` field. */
  title?: InputMaybe<StringFilter>;
  /** Filter by the object’s `updatedDate` field. */
  updatedDate?: InputMaybe<DatetimeFilter>;
  /** Filter by the object’s `updatedUser` field. */
  updatedUser?: InputMaybe<StringFilter>;
  /** Filter by the object’s `vmSpecId` field. */
  vmSpecId?: InputMaybe<StringFilter>;
};

/** A filter to be used against many `ServiceDeployment` object types. All fields are combined with a logical ‘and.’ */
export type VmSpecificationToManyServiceDeploymentFilter = {
  /** Every related `ServiceDeployment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  every?: InputMaybe<ServiceDeploymentFilter>;
  /** No related `ServiceDeployment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  none?: InputMaybe<ServiceDeploymentFilter>;
  /** Some related `ServiceDeployment` matches the filter criteria. All fields are combined with a logical ‘and.’ */
  some?: InputMaybe<ServiceDeploymentFilter>;
};

/** A connection to a list of `VmSpecification` values. */
export type VmSpecificationsConnection = {
  __typename?: 'VmSpecificationsConnection';
  /** A list of edges which contains the `VmSpecification` and cursor to aid in pagination. */
  edges: Array<VmSpecificationsEdge>;
  /** A list of `VmSpecification` objects. */
  nodes: Array<VmSpecification>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The count of *all* `VmSpecification` you could get from the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A `VmSpecification` edge in the connection. */
export type VmSpecificationsEdge = {
  __typename?: 'VmSpecificationsEdge';
  /** A cursor for use in pagination. */
  cursor?: Maybe<Scalars['Cursor']['output']>;
  /** The `VmSpecification` at the end of the edge. */
  node: VmSpecification;
};

/** Methods to use when ordering `VmSpecification`. */
export enum VmSpecificationsOrderBy {
  CreatedDateAsc = 'CREATED_DATE_ASC',
  CreatedDateDesc = 'CREATED_DATE_DESC',
  CreatedUserAsc = 'CREATED_USER_ASC',
  CreatedUserDesc = 'CREATED_USER_DESC',
  DefaultLimitCpuAsc = 'DEFAULT_LIMIT_CPU_ASC',
  DefaultLimitCpuDesc = 'DEFAULT_LIMIT_CPU_DESC',
  DefaultLimitRamAsc = 'DEFAULT_LIMIT_RAM_ASC',
  DefaultLimitRamDesc = 'DEFAULT_LIMIT_RAM_DESC',
  HostingPlanIdAsc = 'HOSTING_PLAN_ID_ASC',
  HostingPlanIdDesc = 'HOSTING_PLAN_ID_DESC',
  Natural = 'NATURAL',
  PrimaryKeyAsc = 'PRIMARY_KEY_ASC',
  PrimaryKeyDesc = 'PRIMARY_KEY_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC',
  UpdatedDateAsc = 'UPDATED_DATE_ASC',
  UpdatedDateDesc = 'UPDATED_DATE_DESC',
  UpdatedUserAsc = 'UPDATED_USER_ASC',
  UpdatedUserDesc = 'UPDATED_USER_DESC',
  VmSpecIdAsc = 'VM_SPEC_ID_ASC',
  VmSpecIdDesc = 'VM_SPEC_ID_DESC'
}
